import {
  ChangeDetectorRef,
  ViewChild,
  ElementRef,
  TemplateRef
} from "@angular/core";
import { Component, OnInit } from "@angular/core";
import { mediaModel } from "./upload-audio-video-images.model";
import { Category, Complexity, Type } from "../services/authentication.service";
import { report, ReportService } from "../services/report.service";
import {
  AuthenticationService,
  TestData,
  CandidateInformation
} from "../services/authentication.service";
import { NgForm, FormBuilder, FormGroup,FormControl, Validators } from "@angular/forms";
import { TestTakerService } from "../services/test_taker.service";
import { Router } from "@angular/router";
import { HttpClient } from "@angular/common/http";
import { MediaMatcher } from "@angular/cdk/layout";
import { MatStepper } from "@angular/material";
import { ExcelService } from "../services/excel.service";
import { questionService } from "../services/question.service";
import Swal from "sweetalert2";
import { NgModule } from "@angular/core";
import { Design } from "../designTest/designTest.model";
import { NgbModalOptions, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { log } from "console";
import { element } from "protractor";
import { QuestionSetService } from "../services/questionset.service";
import { filterBy } from "@progress/kendo-data-query";
import { Location } from "@angular/common";
import { LocationStrategy } from '@angular/common';
import { DOCUMENT } from '@angular/common';
import { Inject } from '@angular/core';
import * as _ from "lodash";
import { CompileShallowModuleMetadata } from "@angular/compiler";
import { last } from "rxjs/operators";



@Component({
  selector: "app-upload-audio-video-images",
  templateUrl: "./upload-audio-video-images.component.html",
  styleUrls: ["./upload-audio-video-images.component.scss"]
})
export class UploadAudioVideoImagesComponent implements OnInit {
  report_details: report = { College_Id: "", Year_Id: "", Question_Set: "" };
  @ViewChild("myInput")
  @ViewChild("stepper")
  private myStepper: MatStepper;
  @ViewChild("text") text: ElementRef;
  @ViewChild("content") modalContent: TemplateRef<any>;
  @ViewChild("edit") modalEdit: TemplateRef<any>;
  @ViewChild("editFielder") modalEditFielder: TemplateRef<any>;
  

  
  myInputVariable: ElementRef;
  result: string[];
  userAdmin: boolean;
  userSuperAdmin: boolean;
  userTestScheduler: boolean;
  userTestTaker: boolean;
  display: boolean;
  overall: boolean;
  questionset: boolean;
  scheduletest: boolean;
  evaluate: boolean;
  mobileQuery: MediaQueryList;
  private _mobileQueryListener: () => void;
  links = ["Super Admin", "Admin", "Test Scheduler", "Test Taker"];
  email;
  user;
  fname;
  lname;
  columns: string[];
  test: TestData = {
    id: "",
    FirstName: "",
    LastName: "",
    Email: "",
    Phone: "",
    Type: ""
  };
  submitted = false;
  registerForm: FormGroup;
  screenWidth: number | undefined;
  screenHeight: number | undefined;
  isCustomStyleApplied: boolean = false;
  cardopen: number = 0;
  compcardopen:number = 0;
  card_opened: boolean = false;
  editcard_array: any = [];
  editCardOfComprehension_array: any = [];
  modalRef: any;
  compmodalRef: any;
  fieldermodalRef: any;
  fieldArray: Array<mediaModel> = [];
  Category;
  Type;
  Complexity;
  section_name: any = [];
  details: boolean;
  fielder: any = [];
  fielder_last_elem: number;
  gettablecount: number = 0;
  newAttribute: any = {};
  check_set: any = [];
  set: any = [];
  dupfield: number = 0;
  dupfieldOfComprehension: number = 0;
  dup_fieldArray: Array<mediaModel> = [];
  dup_fieldArrayOfComprehension: Array<Design> = [];
  updateset: any = [];
  setindex: string;
  compArrIndex:string;
  info: any;
  file: string;
  name: any;
  uploadedFiles: Array<File>;
  imagePaths: string[];
  Question_Category: any;
  Question_Sub_Category: any;
  question_typelist: any;
  question_stylelist: any;
  category: Category = {
    category_name: ""
  };
  
  type: Type = {
    cate_id: "",
    subcategory_id: "",
    style_id:""
  };
  complexity: Complexity = {
    cate_id: "",
    subcategory_id: "",
    type_id: ""
  };
  complexityEmptyCheck: boolean;
  selectedComplexityindex: any;
  selectedComplexity: any;
  selectedtypeindex: any;
  typeEmptyCheck: boolean;
  questiontextEmptyCheck: boolean;
  questionMediaEmptyCheck: boolean;
  selectedtype: any;
  subCategoryEmptyCheck: boolean;
  selectedsubCategoryindex: any;
  selectedsubCategory: any;
  categoryEmptyCheck: boolean;
  selectedCategoryindex: any;
  selectedCategory: any;
  selectedQuestionMedia: any;
  delete_counter: number = 0;
  lastindex_deleted: Boolean = false;
  disableDeleteButton: boolean =false;
  field_push: number;
  setnextcounter: number = 0;
  validation_fail: number = 0;
  duplicate_set_config: boolean;
  lastelem: number;
  org_questioncount: boolean;
  tableIndex: number = 0;
  counter: number = 0;
  typedquestionText: any;
  data: any;
  selectedQuestionMediaindex: any;
  selectedType: any;
  isSelectedImageType: boolean;
  mediaSubCategories : string[] = ["Image","Video","Audio"];
  questionTypeCategories : string[] = ["MCQS_WITH_IMAGES","AudioAnswer","VideoAnswer"];
  filteredCategories: any;
  filteredCategoryArray: string[] = [];
  filteredSubCategories: any;
  filteredSubCategoryArray: string[] = [];
  filteredQuestionTypeArray: string[] = [];
  filteredQuestionTypes: any;
  firstCategoryChange: boolean = false;
  firstTypeChange: boolean = false;
  answer1EmptyCheck: boolean = false;
  typedAnswer1: any;
  answer2EmptyCheck: boolean = false;
  typedAnswer2: any;
  answer3EmptyCheck: boolean = false;
  typedAnswer3: any;
  answer4EmptyCheck: boolean = false;
  typedAnswer4: any;
  answer5EmptyCheck: boolean = false;
  typedAnswer5: any;
  answer6EmptyCheck: boolean =false;
  typedAnswer6: any;
  correctAnswerEmptyCheck: boolean = false;
  typedCorrectAnswer: any;
  showFileUploadError: boolean = false;
  selectedMediaFile: any;
  correctAnswerMismatchCheck: boolean = false;
  allCategoriesArray: string[] = [];
  questionstyleEmptyCheck: boolean;
  typedquestionStyle: any;
  isSelectedQuestionType: boolean;
  isSelectedQuestionStyle: boolean;
  isSelectedTypeEqualsComprehension: boolean = false;
  dataArray =[];
  newAttributes: any = {};
  newComprehensionAttributes: any = {};
  comprehensionArray: any = [];
  compFieldArray: any =[];
  delete_counter_in_comprehension: any;
  tableIndexOfComprehension: any;
  compcard_opened: boolean;
  isSelectedTypeEqualsComprehensionForEdit: boolean = false;
  disableDeleteButtonofComprehension: boolean =false;
  validation_fail_of_comprehension: number = 0;
  dup_comprehensionArray: any = [];
  getTableCountForComprehension = 0;
  ifComprehensionArrayEdited: boolean = false;
  allCompValidationspassed: boolean = false; 
  isSelectedTypeEqualsComprehensionWithFreeText: boolean = false;
  isSelectedTypeEqualsFreeText: boolean = true;
  isSelectedTypeEqualsAudioAnswer: boolean = true;
  isSelectedTypeEqualsVideoAnswer: boolean = true;
  isSelectedTypeEqualsAlgorithm: boolean = true;
  isSelectedTypeEqualsComprehensionFTForEdit: boolean = false;
  Question_Style: any;
  displayCompTableField: boolean = false;
  displayCompTableFieldForFreeText: boolean = false;
 // displayAddCompButton: boolean = false;
  displayAddCompButtonForMcq: boolean = false;
  displayAddCompButtonForFreeText: boolean = false;
  useOfMultipleOptions: boolean = false;
  useOfMultipleOptionsOnlyMCQ: boolean = false;
  filteredStyles: string;
  filteredStyleArray: string[] = [];
  mediaUsedNames : string[] = ["video","audio","image"];
  firststyleclick: boolean = false;
  isDuplicatesDetectedInComprehension: boolean = false;
  lastElement: number;
  duplicateCompQuestionDetected: boolean = false;
  uniqueOptionNotAssigned: boolean = false;
  userEvaluator: boolean;


  constructor(
    private auth: AuthenticationService,
    private router: Router,
    private formBuilder: FormBuilder,
    private http: HttpClient,
    private testtakerservice: TestTakerService,
    changeDetectorRef: ChangeDetectorRef,
    media: MediaMatcher,
    private reportservice: ReportService,
    private excelService: ExcelService,
    private mediaservice: questionService,
    private modal: NgbModal,
    private qs: QuestionSetService,
    private locationStrategy: LocationStrategy,
    @Inject(DOCUMENT) private document: Document
  ) {
    
    this.mobileQuery = media.matchMedia("(max-width: 600px)");
    this._mobileQueryListener = () => changeDetectorRef.detectChanges();
    this.mobileQuery.addListener(this._mobileQueryListener);
  }

  images: string[] = [];
  ngOnInit(): void {
    this.initialzeFielder();
    this.initializeComprehensionAttributes();
    this.getScreenSize();
    this.applyStylesBasedOnResolution();
    this.getCategory();
    this.getAccess();
   // this.createItem();
    this.getTempRowData();
    this.registerForm = this.formBuilder.group({
      data: ["", Validators.required]
    });
    
  
  }
  getScreenSize(): void {
    this.screenWidth = window.innerWidth;
   
    this.screenHeight = window.innerHeight;
    
  }

  applyStylesBasedOnResolution(): void {
    if (this.screenWidth && this.screenHeight) {
    
      if (this.screenWidth < 1366 && this.screenHeight <  641) {
        this.isCustomStyleApplied = true;
       
      
      }
     
    }
  }
  initializeComprehensionAttributes(){
    this.newComprehensionAttributes = {
      // questionTextOfComprehension:'',
      // comprehensionAnswer1:'',
      // comprehensionAnswer2:'',
      // comprehensionAnswer3:'',
      // comprehensionAnswer4:'',
      // comprehensionAnswer5:'',
      // comprehensionAnswer6:'',
      // comprehensionCorrectAnswer:'',
      Answer1:"",
      Answer2:"",
      Answer3:"",
      Answer4:"",
      Answer5:"",
      Answer6:"",
      CorrectAnswer:"",
      Correct_Answer:"",
      category:"",
      complexity:"",
      complexity_id:"",
      q_url:"",
      questionMedia:"",
      questionText:"",
      question_category_id:"",
      question_style_id:"",
      question_sub_category_id:"",
      question_text:"",
      question_type_id:"",
      style:"",
      subcategory:"",
      type:"",
    }
  }

  initialzeFielder(){
    console.log("Checking the new Attributes inside initialize fielder ",this.newAttribute);
    console.log("Inside InitializeFielder Function");
    this.newAttribute = {
      category: '',
      subcategory: '',
      type: '',
      style:'',
      complexity: '',
      questionMedia: '',
      questionText:'',
      question_text: '',
      question_category_id: '',
        question_sub_category_id :'',
        question_type_id:'',
        question_style_id:'',
        complexity_id: '',
        q_url: '',
        Correct_Answer:'',
        Answer1:'',
        Answer2:'',
        Answer3:'',
        Answer4:'',
        Answer5:'',
        Answer6:'',
        CorrectAnswer:''
        
      };
      console.log("Checking the new Attributes before pushing inside initialize fielder",this.newAttribute);
    this.fielder.push(this.newAttribute)
    console.log("F PUSH 1",this.fielder);
  }

  newcheck(){
    console.log("fielder in new check", this.fielder);
    // this.fielder.splice(-1, 1)
    let array = []
    // for(let rec of this.fielder){
    //   let obj={
    //     // "question_text":"",
    //     // 'question_category_id':'', 
    //     // 'question_sub_category_id':'',
    //     // 'question_type_id':'',
    //     // 'complexity_id':'',
    //     // 'q_url':'',
    //     // 'Correct_Answer':'',
    //     // 'Answer1':'',
    //     // 'Answer2':'',
    //     // 'Answer3':'',
    //     // 'Answer4':'',
    //     // 'Answer5':'',
    //     // 'Answer6':''

    //   }
    //   obj.question_text = rec.questionText
    //   obj.question_category_id = rec.question_category_id
    //   obj.question_sub_category_id = rec.question_sub_category_id
    //   obj.question_type_id = rec.question_type_id
    //   obj.complexity_id=rec.complexity_id
    //   obj.q_url=rec.q_url
    //   obj.Correct_Answer = rec.Correct_Answer
    //   obj.Answer1 = rec.Answer1
    //   obj.Answer2 = rec.Answer2
    //   obj.Answer3 = rec.Answer3
    //   obj.Answer4 = rec.Answer4
    //   obj.Answer5 = rec.Answer5
    //   obj.Answer6 = rec.Answer6
    //   if(rec.questionText!= ''){
    //   array.push(obj)
    //   }
    // }
    console.log("array",array)
    // this.mediaservice.uploadImage(array).subscribe()
    this.mediaservice.uploadImage(this.fielder).subscribe(

            (data)=>{
      
              if (data.code == 200) {
      
                Swal.fire({
      
                  title: "Success",
      
                  text: "Questions Uploaded Successfully",
      
                  icon: "success",
      
                  showCancelButton: false,
      
                  confirmButtonText: "OK"
      
                }).then(result => {
      
                  if (result.isConfirmed) {
      
                    this.reset();
      
                  }
      
                });
      
              } else {
      
                Swal.fire({
      
                  title: "Alert",
      
                  text: "Question Upload failed",
      
                  icon: "warning",
      
                  showCancelButton: false,
      
                  confirmButtonText: "OK"
      
                }).then(result => {
      
                  if (result.isConfirmed) {
      
                    this.reset();
      
                    // this.exportAsXLSX()
      
                  }
      
                });
      
              }
      
            },err => {
      
              console.error(err);
      
              Swal.fire({
      
                title: "Alert",
      
                text: err,
      
                icon: "warning",
      
                showCancelButton: false,
      
                confirmButtonText: "OK"
      
              }).then(result => {
      
                if (result.isConfirmed) {
      
                  this.reset();
      
                  // this.exportAsXLSX()
      
                }
      
              });
      
            }
      
          )
    
  }
//   newcheck(){
//     console.log("fielder in new check", this.fielder);
//     // this.fielder.splice(-1, 1)
//     let array = []
//     // for(let rec of this.fielder){
//     //   let obj={
//     //     // "question_text":"",
//     //     // 'question_category_id':'', 
//     //     // 'question_sub_category_id':'',
//     //     // 'question_type_id':'',
//     //     // 'complexity_id':'',
//     //     // 'q_url':'',
//     //     // 'Correct_Answer':'',
//     //     // 'Answer1':'',
//     //     // 'Answer2':'',
//     //     // 'Answer3':'',
//     //     // 'Answer4':'',
//     //     // 'Answer5':'',
//     //     // 'Answer6':''

//     //   }
//     //   obj.question_text = rec.questionText
//     //   obj.question_category_id = rec.question_category_id
//     //   obj.question_sub_category_id = rec.question_sub_category_id
//     //   obj.question_type_id = rec.question_type_id
//     //   obj.complexity_id=rec.complexity_id
//     //   obj.q_url=rec.q_url
//     //   obj.Correct_Answer = rec.Correct_Answer
//     //   obj.Answer1 = rec.Answer1
//     //   obj.Answer2 = rec.Answer2
//     //   obj.Answer3 = rec.Answer3
//     //   obj.Answer4 = rec.Answer4
//     //   obj.Answer5 = rec.Answer5
//     //   obj.Answer6 = rec.Answer6
//     //   if(rec.questionText!= ''){
//     //   array.push(obj)
//     //   }
//     // }
//     console.log("array",array)

//    // this.eliminateDuplicateQuestionsFromFielder(this.fielder)
//     // this.mediaservice.uploadImage(array).subscribe()
//    // this.fielder.splice(-1,1);
// // var nextindex;
// //     for(var i = 0;i<=this.fielder.length;i++){
// //       nextindex = i+1;
// //       console.log("Qt print",this.fielder[i].questionText);
// //       console.log("Next Index QText",this.fielder[nextindex].questionText)
// //       if(this.fielder[i].questionText === this.fielder[nextindex].questionText){
// //         this.fielder.splice(i,1);
// //         console.log("SPliced the duplicate");
// //       }
// //       console.log("Updated Fielder",this.fielder);
// //     }

//     // console.log("FIELDER AFTER ELIMINATING DUPLICATE",this.fielder);

//     this.mediaservice.uploadImage(this.fielder).subscribe(

//             (data)=>{
      
//               if (data.code == 200) {
      
//                 Swal.fire({
      
//                   title: "Success",
      
//                   text: "Questions Uploaded Successfully",
      
//                   icon: "success",
      
//                   showCancelButton: false,
      
//                   confirmButtonText: "OK"
      
//                 }).then(result => {
      
//                   if (result.isConfirmed) {
      
//                     this.reset();
      
//                   }
      
//                 });
      
//               } else {
      
//                 Swal.fire({
      
//                   title: "Alert",
      
//                   text: "Question Upload failed",
      
//                   icon: "warning",
      
//                   showCancelButton: false,
      
//                   confirmButtonText: "OK"
      
//                 }).then(result => {
      
//                   if (result.isConfirmed) {
      
//                     this.reset();
      
//                     // this.exportAsXLSX()
      
//                   }
      
//                 });
      
//               }
      
//             },err => {
      
//               console.error(err);
      
//               Swal.fire({
      
//                 title: "Alert",
      
//                 text: err,
      
//                 icon: "warning",
      
//                 showCancelButton: false,
      
//                 confirmButtonText: "OK"
      
//               }).then(result => {
      
//                 if (result.isConfirmed) {
      
//                   this.reset();
      
//                   // this.exportAsXLSX()
      
//                 }
      
//               });
      
//             }
      
//           )
    
//   }

  // eliminateDuplicateQuestionsFromFielder(fielderArr){
  //   for(var i = 0;i<fielderArr.length;i++){
  //     if(fielderArr[i].questionText == fielderArr[i+1].questionText){
  //       fielderArr.splice(i,1);
  //       console.log("SPliced the duplicate");
  //     }
  //   }
  // }

  getCategory() {
    //Old Approach
    // this.auth.category(this.category).subscribe(
    //New Approach for MCQcategory

    this.auth.MCQcategory().subscribe(
      (data) => {
        
        this.Question_Category = data.results;
        console.log("Data.res inside ques cat",data.results);
        console.log("Qoestt",this.Question_Category)
        // this.filteredCategories = this.Question_Category.find(value =>
        //   //console.log("Valuescsa",value);
        //   value.Category_Name === "Media"
        //  // console.log("ValuCAte",value.Category_Name);
        //  // console.log("Condi",value.Category_Name === "Media");
        // )
        this.details = true;
        // console.log("FilterCAtaegor",this.filteredCategories)
        // this.filteredCategoryArray.push(this.filteredCategories)
        // return this.filteredCategoryArray;
        // this.allCategoriesArray.push(this.Question_Category);
        // console.log("All Categories",this.allCategoriesArray)
        // return this.allCategoriesArray;
        return this.Question_Category;
      },
      err => {
        console.error(err);
      }
    );
  }

  

  getTempRowData() {
    
    console.log("Inside getTemprow Data ......");
    this.newAttribute = {
      category: "",
    subcategory: "",
    questionText: "",
    type: "",
    style:'',
    questionMedia: "",
    complexity: "",
    question_text: '',
        question_category_id: '',
        question_sub_category_id :'',
        question_type_id:'',
        question_style_id:'',
        complexity_id: '',
        q_url: '',
        Correct_Answer:'',
        Answer1:'',
        Answer2:'',
        Answer3:'',
        Answer4:'',
        Answer5:'',
        Answer6:''

    };


    this.fieldArray.push(this.newAttribute);
    console.log("FA PUSH 1",this.fieldArray);
    console.log("TTHIS FFIELDER INSIDE GETT TEMP ROW DATA FUNC",this.fielder);
  }

  get f() {
    return this.registerForm.controls;
  }

  // getAccess() {
  //   this.user = sessionStorage.getItem("user");
  //   this.fname = sessionStorage.getItem("fname");

  //   this.lname = sessionStorage.getItem("lname");

  //   if (this.user === "2") {
  //     this.userAdmin = true;
  //     this.userSuperAdmin = false;
  //     this.userTestScheduler = true;
  //   } else if (this.user === "1") {
  //     this.userAdmin = true;
  //     this.userSuperAdmin = true;
  //     this.userTestScheduler = true;
  //   } else if (this.user === "3") {
  //     this.userAdmin = false;
  //     this.userSuperAdmin = false;
  //     this.userTestScheduler = true;
  //   }
  // }

  
getAccess(){
  this.user = sessionStorage.getItem('user');
  this.fname = sessionStorage.getItem('fname');

  this.lname = sessionStorage.getItem('lname');


  if (this.user === '1') {
    this.userAdmin = true;
    this.userTestScheduler = false;
    this.userEvaluator = false;
  } else if (this.user === '2') {
    this.userEvaluator = true;
    this.userAdmin = false;
    this.userTestScheduler = false;
  } else if (this.user === '3') {
    this.userTestScheduler = true;
    this.userAdmin = false;
    this.userEvaluator = false;  
  }
}

  fileChange(element) {
    this.uploadedFiles = element.target.files;

    this.file = this.uploadedFiles[0].name;
  }

  Selectfile(event) {
    if (event.target.files.length > 0) {
      const file = event.target.files[0];
      this.selectedMediaFile = file;
    }
  }
  reset() {
    // this.myInputVariable.nativeElement.value = "";
    window.location.reload()
    // this.router.navigateByUrl('upload_media')
  }

  upload() {
    this.submitted = true;
    const fileInput = document.querySelector('input[type="file"]') as HTMLInputElement
   
   console.log("file lileInput.files[0]ength",fileInput.files[0])
   if (fileInput.files[0]) {
      this.showFileUploadError = false
      console.log("Inside name length",this.selectedMediaFile.length)
    var formData: any = new FormData();
    formData.append("file",this.selectedMediaFile);

    this.http.post("/users/upload/upload_media", formData).subscribe(
      response => {
        console.log("Inside response =>");
        // const res = (typeof response === 'string')  // ? JSON.parse(response) : response;
        const res =
          typeof response === "string" ? JSON.parse(response) : response;
        // const res = response;
        console.log("RESPONSE FROM UPLOAD JS MEDIA UPLOAD  :  ", response);
        if (res.code == 200) {
          console.log("Inside SWAL.Fire success");
          Swal.fire({
            title: "Success",
            text: "Media Uploaded Successfully",
            icon: "success",
            showCancelButton: false,
            confirmButtonText: "OK"
          }).then(result => {
            if (result.isConfirmed) {
              this.reset();
            }
          });
        } else {
          console.log("Inside SWAL.Fire FAiled");
          Swal.fire({
            title: "Alert",
            text: "Media Upload failed",
            icon: "warning",
            showCancelButton: false,
            confirmButtonText: "OK"
          }).then(result => {
            if (result.isConfirmed) {
              this.reset();
              // this.exportAsXLSX()
            }
          });
        }
      },

      error => console.error(error)
    );
  
   }
    else{

      this.showFileUploadError = true
    }

    console.log("Inside name length", this.showFileUploadError)
  }
  
  open_set_media_card(index) {
    this.cardopen = this.cardopen + 1

    //Open modal on pressing escape
   // this.get_section_name();
    let ngbModalOptions: NgbModalOptions = {
      backdrop: 'static',
      keyboard: false
    };
   console.log("THIS.ModalContent :: ",this.modalContent);
   // console.log("THIS.MODALOPTIONS",this.ngbModalOptions);
    this.modalRef = this.modal.open(this.modalContent, ngbModalOptions)
   // console.log("THIS.MODALREF",this.modalRef);
    if (this.cardopen > 1) {
      this.card_opened = true
      this.set.splice(0, this.set.length)
      this.dupfield = this.dupfield + 1;



      if (this.dupfield > 1) {
        this.dup_fieldArray.splice(0, this.dup_fieldArray.length)


      }
      console.log(" 22 New Attribute printing before dup_fieldArray push",this.newAttribute);
      this.dup_fieldArray.push(this.newAttribute)
      console.log("OUTPUT ARR !!!!! ",this.dup_fieldArray);
      console.log("New comp attrr",this.newComprehensionAttributes);
      this.dup_comprehensionArray.push(this.newComprehensionAttributes);
      console.log("DUUUP comp arr ",this.dup_comprehensionArray);

    }



  }

  open_edit_media_card(index) {
    // alert(index);
    this.cardopen = this.cardopen + 1
   // this.get_section_name();
   console.log("EDIT CARD INDEX",index);
    this.editcard_array = [];
    console.log("FA 2 ",this.fielder);
    
    console.log("### Field arr",this.fielder[index]);

    this.editcard_array.push(this.fielder[index])
    console.log("@@@@ Field arr",this.fielder[index]);

    console.log("Edit Card array ....",this.editcard_array);

    localStorage.setItem('setindex', index)
    //Open modal on pressing escape
    let ngbModalOptions: NgbModalOptions = {
      backdrop: 'static',
      keyboard: false
    };

    if(this.editcard_array[0].category != 0)
    {
      console.log("Inside open EDIT card IF ");
    this.modalRef = this.modal.open(this.modalEditFielder, ngbModalOptions)
    console.log("THIS MODAL REF ",this.modalRef);
    }

  }

  open_edit_comp_card(index){

console.log("Print of the index in open edit comp card ",index);
  
    console.log("Inside the edit funcc of comp ....");
    this.compcardopen = this.compcardopen + 1;
    console.log("Card open  val....",this.compcardopen);
    this.editCardOfComprehension_array = [];
    console.log("1234 edit card comp array",this.editCardOfComprehension_array);
    console.log("Before push of edit card array ....",this.editCardOfComprehension_array);
    this.editCardOfComprehension_array.push(this.comprehensionArray[index])
    console.log("After push of edit card array...",this.editCardOfComprehension_array);

    localStorage.setItem('setindex', index)
    //Open modal on pressing escape
    let ngbModalOptions: NgbModalOptions = {
      backdrop: 'static',
      keyboard: false
    };

    if(this.editCardOfComprehension_array[0].questionText != 0)
    {
      console.log("Inside open EDIT card IF ");
    this.compmodalRef = this.modal.open(this.modalEdit, ngbModalOptions)

    console.log("THIS Comp MODAL REF ",this.compmodalRef);
    }
  }

//   open_edit_comp_card(index) {
//     this.compcardopen = this.compcardopen + 1
// console.log("Inside edit of comp first",this.compcardopen);
//     //Open modal on pressing escape
//    // this.get_section_name();
//     let ngbModalOptions: NgbModalOptions = {
//       backdrop: 'static',
//       keyboard: false
//     };
//    console.log("THIS.ModalContent :: ",this.modalContent);
//    // console.log("THIS.MODALOPTIONS",this.ngbModalOptions);
//     this.modalRef = this.modal.open(this.modalContent, ngbModalOptions)
//    // console.log("THIS.MODALREF",this.modalRef);
//    // if (this.compcardopen > 1) {
//       if (this.compcardopen > 0) {
//       this.compcard_opened = true
//       console.log("112",this.comprehensionArray);
//       this.comprehensionArray.splice(0, this.comprehensionArray.length)
//       console.log("114",this.comprehensionArray);
//       this.dupfieldOfComprehension = this.dupfieldOfComprehension + 1;
//       console.log("The count of dup Field arr of comp ",this.dup_fieldArrayOfComprehension);

//       console.log("Inside edit of comp second ",this.comprehensionArray);



//       if (this.dupfield > 1) {
//         this.dup_fieldArrayOfComprehension.splice(0, this.dup_fieldArrayOfComprehension.length)
//       }
//       this.dup_fieldArrayOfComprehension.push(this.newAttribute)
//       console.log("OUTPUT ARR !!!!! ",this.dup_fieldArrayOfComprehension);

//     }



//   }



  getNameForQuestionFields(field){
    console.log("Inside Get name for question fields");
console.log("Fielder inside getNameForQuestionFields ",this.fielder);
    console.log("Printing this.set as field in getNameForQuestionFields...",field);
    console.log("Printing field length",field.length);
    const currentDomain = this.locationStrategy.getBaseHref() + this.document.location.origin;

    // var indexOnTheFielder = field.length - this.comprehensionArray.length;
    // console.log("click click click index of the fieder",indexOnTheFielder);
    
    for(let i=0;i<field.length;i++){
    console.log(`field[i] *************${i}`,field[i])
    
    const categoryNameFromDB = this.Question_Category.find(value => value.Id == field[i].category)
    console.log(`categoryNameFromDB *************${i}`,categoryNameFromDB)
    const sub_categoryNameFromDB  = this.Question_Sub_Category.find(value =>
      value.Id == field[i].subcategory
   )
   console.log(`sub_categoryNameFromDB **************${i}`,sub_categoryNameFromDB)
   const typeNameFromDB  = this.question_typelist.find(value =>
    value.Id == field[i].type
 )
console.log("3",typeNameFromDB)
 const styleNameFromDB  = this.question_stylelist.find(value =>
  value.Id == field[i].style
  )
console.log("4",styleNameFromDB);
 const complexityNameFromDB  = this.Complexity.find(value =>
  value.Id == field[i].complexity
  )

  console.log("5",complexityNameFromDB)

  console.log(`Print of fielder in ${i} index `,this.fielder);
  
  this.fielder[this.counter].question_category_id = field[i].category
  this.fielder[this.counter].question_sub_category_id = field[i].subcategory
  this.fielder[this.counter].question_type_id = field[i].type
  this.fielder[this.counter].question_style_id= field[i].style
  this.fielder[this.counter].complexity_id = field[i].complexity
  console.log("9090 ",this.fielder[this.counter].category);
  this.fielder[this.counter].category = categoryNameFromDB.Category_Name
  this.fielder[this.counter].subcategory = sub_categoryNameFromDB.Sub_Category_Name
  this.fielder[this.counter].complexity = complexityNameFromDB.Complexity_Name
  this.fielder[this.counter].type = typeNameFromDB.Name
  this.fielder[this.counter].style = styleNameFromDB.Name
  this.fielder[this.counter].questionText = field[i].questionText
  this.fielder[this.counter].questionMedia = field[i].questionMedia
  this.fielder[this.counter].Answer1 = field[i].Answer1.trim()
  this.fielder[this.counter].Answer2 = field[i].Answer2.trim()
  this.fielder[this.counter].Answer3 = field[i].Answer3.trim()
  this.fielder[this.counter].Answer4 = field[i].Answer4.trim()
  this.fielder[this.counter].Answer5 = field[i].Answer5.trim()
  this.fielder[this.counter].Answer6 = field[i].Answer6.trim()
  this.fielder[this.counter].Correct_Answer = field[i].Correct_Answer.trim()
  this.fielder[this.counter].q_url = `${currentDomain}/uploads/${styleNameFromDB.Name.toLowerCase()}/${field[i].questionMedia}`

 
  console.log(`${i} index THIS.FIELDER PRINTING INSIDE getNameForQuestionFields  :::`, this.fielder[i]);
  console.log("Counter before inc ",this.counter);
  this.counter = this.counter + 1;
  console.log("Counter after inc",this.counter);

  
 this.displayCompTableField = false;
 this.displayCompTableFieldForFreeText = false;
 this.displayAddCompButtonForMcq = false;
 this.displayAddCompButtonForFreeText = false;
 this.useOfMultipleOptions = false;
this.initialzeFielder();
  //this.displayAddCompButton = false;

 }


 console.log('ZZZZ Check comp edited TRUE OR FALSE ',this.ifComprehensionArrayEdited)
// if(this.ifComprehensionArrayEdited == true){
//   console.log("12345678");
//   this.modalRef.close(this.modalContent)
//   console.log("After that")
// }
//this.fielder.splice(-1,2);
 console.log("Finally printing the FIELDER ARRAY ",this.fielder);

  }

  async update_set_media (index , field) {
    this.updateset = this.updateset + 1
    this.setindex = localStorage.getItem('setindex')
    console.log("Input into the update_set_media ",field)
    console.log("Indexxx",index);
    console.log("Fielddd",field.question_sub_category_id);
    const categoryNameFromDB = this.Question_Category.find(value => value.Id == field.question_category_id)
    //const category = this.Question_Category.find(value => value.Id == field.category)
    
    const sub_category = await this.Question_Sub_Category.find(value =>
      value.Id == field.question_sub_category_id
   )
   
   const type = await this.question_typelist.find(value =>
    value.Id == field.question_type_id
 )

 const style = await this.question_stylelist.find(value =>
  value.Id == field.question_style_id
  )

 const complexity = await this.Complexity.find(value =>
  value.Id == field.complexity_id
  )
  const currentDomain = this.locationStrategy.getBaseHref() + this.document.location.origin;

console.log("3456",categoryNameFromDB);
    this.fielder[this.setindex].category = categoryNameFromDB.Category_Name
    this.fielder[this.setindex].subcategory = sub_category.Sub_Category_Name
    this.fielder[this.setindex].complexity = complexity.Complexity_Name
    this.fielder[this.setindex].type = type.Name
    this.fielder[this.setindex].style = style.Name
    this.fielder[this.setindex].questionText = field.questionText
    this.fielder[this.setindex].questionMedia = field.questionMedia
    this.fielder[this.setindex].q_url = `${currentDomain}/uploads/${style.Name.toLowerCase()}/${field.questionMedia}`
    // this.fielder[this.setindex].q_url = `/assets/${sub_category.Sub_Category_Name.toLowerCase()}/${field.questionMedia}`
    console.log("THIS>FIELDER 2", this.fielder);


    //Karthikeyan
    if(field.category == ""){
      this.categoryEmptyCheck = true;
    }else{
      this.categoryEmptyCheck = false;
    }
    if(field.subcategory == ""){
      this.subCategoryEmptyCheck = true;
    }else{
      this.subCategoryEmptyCheck = false;
    }
    if(field.style == ""){
      this.questionstyleEmptyCheck = true;
    }else{
      this.questionstyleEmptyCheck = false;
    }
    if(field.type == ""){
      this.typeEmptyCheck = true;
    }else{
      this.typeEmptyCheck = false;
    }
    if(field.complexity == ""){
      this.complexityEmptyCheck = true;
    }else{
      this.complexityEmptyCheck = false;
    }
    if(field.questionMedia == ""){
      this.questionMediaEmptyCheck = true;
    }else{
      this.questionMediaEmptyCheck = false;
    }
    if(field.questionText == ""){
      this.questiontextEmptyCheck = true;
    }else{
      this.questiontextEmptyCheck = false;
    }
    if(field.Answer1.trim() == ""){
    this.answer1EmptyCheck = true;
    }else{
    this.answer1EmptyCheck = false;
    }

    if(field.Answer2.trim() == ""){
      this.answer2EmptyCheck = true;
      }else{
      this.answer2EmptyCheck = false;
    }

    if(field.Answer3.trim() == ""){
        this.answer3EmptyCheck = true;
      }else{
        this.answer3EmptyCheck = false;
    }

    if(field.Answer4.trim() == ""){
      this.answer4EmptyCheck = true;
    }else{
      this.answer4EmptyCheck = false;
  }

  if(field.Correct_Answer.trim() == ""){
    this.correctAnswerEmptyCheck = true;
  }else{
    this.correctAnswerEmptyCheck = false;
}

if(field.Correct_Answer.trim() != field.Answer1.trim() && field.Correct_Answer.trim() != field.Answer2.trim() && field.Correct_Answer.trim() != field.Answer3.trim() && field.Correct_Answer.trim() != field.Answer4.trim()){
  this.correctAnswerMismatchCheck = true;
}else{
  this.correctAnswerMismatchCheck = false;
}






console.log("Printint the correct answer mismatch booelan",this.correctAnswerMismatchCheck);
console.log("Printint the questiontextEmptyCheck ",this.questiontextEmptyCheck);
console.log("Printint the ans1 ",this.answer1EmptyCheck);
console.log("Printint the ans2 ",this.answer2EmptyCheck);
console.log("Printint the ans3 ",this.answer3EmptyCheck);
console.log("Printint the ans4 ",this.answer4EmptyCheck);
console.log("Printint the CA ",this.correctAnswerEmptyCheck);
if(this.categoryEmptyCheck == false && this.subCategoryEmptyCheck == false && this.questionstyleEmptyCheck == false && this.typeEmptyCheck == false && this.questionMediaEmptyCheck == false &&  this.questiontextEmptyCheck == false ){

    this.modalRef.close(this.modalEditFielder)
    console.log("Comp Modall Reff",this.compmodalRef);

  }else{
  console.log("Check all Fields in the edit card ")
  }


          

      // setTimeout(() => {
      //   this.modalRef.close(this.modalEdit)
      // },5000)
      
   

  }

  updateOfComprehension(index,field){
console.log("Fieldddd",field);
    this.ifComprehensionArrayEdited = true;
    console.log("Comp edited true or false ",this.ifComprehensionArrayEdited);
    console.log("Index of selected : ",index);
    this.compArrIndex = localStorage.getItem('compArrIndex')

    console.log("Comp card array",this.comprehensionArray)
    console.log("Edit acrd array ",this.editCardOfComprehension_array)
    
        console.log("FFFIEDER",this.fielder);
        console.log("0 comp card consoles ",this.comprehensionArray.questionText);
        console.log("1Edit card consoles ",this.editCardOfComprehension_array.questionText);
        console.log("2Edit card consoles ",this.editCardOfComprehension_array.Answer1);
        console.log("3Edit card consoles ",this.editCardOfComprehension_array.Answer3);
    
    if(field.questionText == ""){
      this.questiontextEmptyCheck = true;
    }else{
      this.questiontextEmptyCheck = false;
    }
    if(field.Answer1 == ""){
      if(this.isSelectedTypeEqualsComprehensionWithFreeText){
        this.answer1EmptyCheck = false;
      }else{
    this.answer1EmptyCheck = true;
      }
    }else{
    this.answer1EmptyCheck = false;
    }

    if(field.Answer2 == ""){
      if(this.isSelectedTypeEqualsComprehensionWithFreeText){
        this.answer2EmptyCheck = false;
      }else{
    this.answer2EmptyCheck = true;
      }
      }
      else{
      this.answer2EmptyCheck = false;
    }

    if(field.Answer3 == ""){
      if(this.isSelectedTypeEqualsComprehensionWithFreeText){
        this.answer3EmptyCheck = false;
      }else{
    this.answer3EmptyCheck = true;
      }
      }else{
        this.answer3EmptyCheck = false;
    }

    if(field.Answer4 == ""){
      if(this.isSelectedTypeEqualsComprehensionWithFreeText){
        this.answer4EmptyCheck = false;
      }else{
    this.answer4EmptyCheck = true;
      }
    }else{
      this.answer4EmptyCheck = false;
  }

  if(field.Correct_Answer == ""){
    if(this.isSelectedTypeEqualsComprehensionWithFreeText){
      this.correctAnswerEmptyCheck = false;
    }else{
  this.correctAnswerEmptyCheck = true;
    }
  }else{
    this.correctAnswerEmptyCheck = false;
}

if(field.Correct_Answer != field.Answer1 && field.Correct_Answer != field.Answer2 && field.Correct_Answer != field.Answer3 && field.Correct_Answer != field.Answer4){
  if(this.isSelectedTypeEqualsComprehensionWithFreeText){
    this.correctAnswerMismatchCheck = false;
  }else{
this.correctAnswerMismatchCheck = true;
  }
}else{
  this.correctAnswerMismatchCheck = false;
}


console.log("Printint the correct answer mismatch booelan",this.correctAnswerMismatchCheck);
console.log("Printint the questiontextEmptyCheck ",this.questiontextEmptyCheck);
console.log("Printint the ans1 ",this.answer1EmptyCheck);
console.log("Printint the ans2 ",this.answer2EmptyCheck);
console.log("Printint the ans3 ",this.answer3EmptyCheck);
console.log("Printint the ans4 ",this.answer4EmptyCheck);
console.log("Printint the CA ",this.correctAnswerEmptyCheck);
if(this.isSelectedTypeEqualsComprehensionWithFreeText){
  if(this.questiontextEmptyCheck == false){
    this.compmodalRef.close(this.modalEdit)
    console.log("Comp Modall Reff",this.compmodalRef);
  }else{
    console.log("Check the question text !! It is empty  ");
    }

}else{
if(this.questiontextEmptyCheck == false && this.answer1EmptyCheck == false && this.answer2EmptyCheck == false && this.answer3EmptyCheck == false && this.answer4EmptyCheck == false && this.correctAnswerEmptyCheck == false && this.correctAnswerMismatchCheck == false){


    this.compmodalRef.close(this.modalEdit)
    console.log("Comp Modall Reff",this.compmodalRef);

  }else{
  console.log("Check all Fields")
  }
}
}

  // deleteFieldValueInComprehensionArray(index) {
  //   this.delete_counter_in_comprehension = 0;
  // //  this.lastindex_deleted = false;
  //   this.getTableCountForComprehension = this.getTableCountForComprehension - 1
  //   this.tableIndexOfComprehension = index
  //   console.log("index printingggg....",index)
  //   // if(index==0){
  //   //
  //   // this.fieldduplicatearray.push(this.fieldArray[0])
  //   // }

  //   console.log("^^^this.fieldArray.length",this.fieldArray.length)

  //   if(this.fieldArray.length-1 == 0)
  //   {
  //     console.log("Inside If OF del comp cond 1");
  //     this.fieldArray.push(this.newAttribute)
  //     console.log("FA PUSH 3",this.fieldArray);
  //     this.fielder.push(this.newAttribute)
  //     console.log("F PUSH 2 ",this.fielder);
  //     this.disableDeleteButtonofComprehension = true
  //   }

  //   if (index == this.fieldArray.length - 1) {
  //     console.log("Inside if of del comp cond 2");
  //     this.getTableCountForComprehension = this.getTableCountForComprehension + 1
  //     this.lastindex_deleted =  true
  //   }

  //   this.comprehensionArray.splice(index,1)
    
  //   this.fielder.splice(index, 1);
  //   this.fieldArray.splice(index, 1);
  //   //this.check_set.splice(index, 1);

  //   this.initializeComprehensionAttributes();
  //   this.delete_counter_in_comprehension = this.delete_counter_in_comprehension + 1

  //   console.log("After delete func in Comprehension array ::::",this.comprehensionArray);
  //   console.log("deleted fieldArray",this.fieldArray);
  //   console.log("After delete in Fielder ",this.fielder);
  //   console.log("delete counter value : ", this.delete_counter_in_comprehension);

  // }

  deleteFieldValueInComprehensionArray(index) {
    this.delete_counter_in_comprehension = 0;
  //  this.lastindex_deleted = false;
    //this.getTableCountForComprehension = this.getTableCountForComprehension - 1
   // this.counter = this.counter - 1
    //this.tableIndexOfComprehension = index
    console.log("index printingggg....",index)
   

    console.log("^^^this.comparr.length",this.comprehensionArray.length)


console.log("Checking index here ",index);
console.log("Checking of fielder length - 1 here ",this.fielder.length - 1)
//     if (this.comprehensionArray.length - 1 < 1) {
//       //console.log("Inside if of del comp cond 2");
//       //this.getTableCountForComprehension = this.getTableCountForComprehension + 1
// //this.counter = this.counter + 1

//       this.lastindex_deleted =  true
// //this.initialzeFielder();
//     }

    this.comprehensionArray.splice(index,1)
    
    //this.fielder.splice(index, 1);
  // this.fieldArray.splice(index, 1);
   //this.check_set.splice(index, 1);
//this.set.splice(index, 1)

    
   // this.delete_counter_in_comprehension = this.delete_counter_in_comprehension + 1

    console.log("deleted set",this.set)
    
    console.log("After delete func in Comprehension array ::::",this.comprehensionArray);
    console.log("deleted fieldArray",this.fieldArray);
    console.log("After delete in Fielder ",this.fielder);
    console.log("delete counter value : ", this.delete_counter_in_comprehension);

  }



  deleteFieldValue(index) {
    this.delete_counter = 0;
  //  this.lastindex_deleted = false;
    // this.gettablecount = this.gettablecount - 1
    this.counter = this.counter - 1
    // this.tableIndex = index
    console.log("index%%%",index)
    // if(index==0){
    //
    // this.fieldduplicatearray.push(this.fieldArray[0])
    // }

    console.log("^^^this.fieldArray.length",this.fieldArray.length)

    // if(this.fieldArray.length-1 == 0)
    // {
    //   this.fieldArray.push(this.newAttribute)
    //   console.log("FA PUSH 3",this.fieldArray);
    //   this.fielder.push(this.newAttribute)
    //   console.log("F PUSH 2 ",this.fielder);
    //   this.disableDeleteButton = true
    // }
console.log("Checking index here ",index);
console.log("Checking of fielder length - 1 here ",this.fielder.length - 1)
    if (this.fielder.length - 1 < 1) {
      // this.gettablecount = this.gettablecount + 1
      console.log("In");
      this.counter = this.counter + 1
      console.log("Counter console inside if ",this.counter);
      this.lastindex_deleted =  true
      this.initialzeFielder();
    }
    console.log("Counter console outside ",this.counter);
    console.log("deleted fieldArray",this.fieldArray)
    this.fielder.splice(index, 1);
    // this.fieldArray.splice(index, 1);
    this.check_set.splice(index, 1);
    this.set.splice(index, 1)
    this.delete_counter = this.delete_counter + 1
    console.log("deleted set",this.set)
    

  }

  categorychange(event: any, field: any) {
    let sample = event.target.value;
    for (var i = 0; i < this.Question_Category.length; i++) {
      if (this.Question_Category[i].Id == sample) {
        field.category_name = this.Question_Category[i].Category_Name;
      }
    }
  }

  subcategorychange(event: any, field: any) {
    let sample = event.target.value;
    for (var i = 0; i < this.Question_Sub_Category.length; i++) {
      if (this.Question_Sub_Category[i].Id == sample) {
        field.subcategory_name = this.Question_Sub_Category[
          i
        ].Sub_Category_Name;
      }
    }
  }

  mediacategorychange(event: any, field: any){
    let mediaSubCategoryId = event.target.value;
    for (var i = 0; i < this.Question_Sub_Category.length; i++) {
      if (this.Question_Sub_Category[i].Id == mediaSubCategoryId) {
        field.subcategory_name = this.Question_Sub_Category[
          i
        ].Sub_Category_Name;
      }
    }
  }

  typechange(event: any, field: any) {
    let sample = event.target.value;
    for (var i = 0; i < this.question_typelist.length; i++) {
      if (this.question_typelist[i].typeid == sample) {
        field.type_name = this.question_typelist[i].Name;
      }
    }
  }

  stylechange(event: any, field: any) {
    let sample = event.target.value;
    for (var i = 0; i < this.question_stylelist.length; i++) {
      if (this.question_stylelist[i].typeid == sample) {
        field.type_name = this.question_stylelist[i].Name;
      }
    }
  }





  complexitychange(event: any, field: any) {
    let sample = event.target.value;
    for (var i = 0; i < this.Complexity.length; i++) {
      console.log("Complexity of the  for loop ",this.Complexity);

      if (this.Complexity[i].Id == sample) {
        field.complexity_name = this.Complexity[i].Complexity_Name;
        console.log("Printing Complexity of i ....",this.Complexity[i].Complexity_Name);
      }
    }
    console.log("Complexity OUTSIDE LOOP #####",this.Complexity);
  }

  selectChangeHandler(event: any, i: any) {
    var map = new Map();
    
    this.categoryEmptyCheck = false;

    this.selectedCategoryindex = i;
    
    this.selectedCategory = event.target.value;
    console.log("Slected category",this.selectedCategory);


    

    

    this.category.category_name = this.selectedCategory;
    
   // console.log(this.category.category_name);
    this.type.cate_id = this.selectedCategory;
    
    this.complexity.cate_id = this.selectedCategory;
    
    //Old Approach
    // this.auth.subcategory(this.category).subscribe(
    //New Approach for MCQsubcategory
    this.auth.MCQsubcategory().subscribe(
      data => {
        // this.Question_Sub_Category = data.results;

        // console.log(this.Question_Sub_Category);

        // this.details = true;
        // return this.Question_Sub_Category;


        
        
        this.Question_Sub_Category = data.results;
        console.log("Data.res inside ques cat",data.results);
        console.log("Qoestt",this.Question_Sub_Category)

      ///   if(this.firstCategoryChange == false){
      ///   this.Question_Sub_Category.forEach(element => {
      ///     if(this.mediaSubCategories.includes(element.Sub_Category_Name)){
      ///       this.filteredSubCategoryArray.push(element)
      ///     }
        
      ///   });
      ///   this.firstCategoryChange = true;
      /// }
        // this.filteredSubCategories = this.Question_Sub_Category.find(value =>
        //   this.mediaSubCategories.includes(value.Sub_Category_Name)
          
         
        // )
        this.details = true;
        console.log("FilterCAtaegor",this.filteredSubCategories)
       //this.filteredSubCategoryArray.push(this.filteredSubCategories)
        console.log("Filtersub arr",this.filteredSubCategoryArray)
        return this.Question_Sub_Category;
      },
      err => {
        console.error(err);
      }
    );
  }
   
  questionMediaChangeHandler(event: any, i: any){
    this.questionMediaEmptyCheck = false;
    this.selectedQuestionMediaindex = i;

    this.selectedQuestionMedia = event.target.value;


  }
  //complexity changehandler
  complexityChangeHandler(event: any) {
    console.log("Checking complexity for comp attrib",this.newComprehensionAttributes);
    console.log("check new attr in compchange ",this.newAttribute);
    this.complexityEmptyCheck = false;
   // this.selectedComplexityindex = i;
    
   // this.auth.types().subscribe();
    // this.auth.types().subscribe(
    //   data => {
    //     this.complexity = data.results;
    //     console.log("Inside complexity of complexity Change handler ",this.complexity);

    //     this.details = true;
    //     return this.complexity;
    //   },
    //   err => {
    //     console.error(err);
    //   }
    // );

     this.selectedComplexity = event.target.value;
    // k this.selectedQuestionMedia = this.selectedComplexity;
  }

  questionTextChangeHandler(event: any) {
    this.questiontextEmptyCheck = false;
   // this.typedquestionTextindex = i;
    console.log("questionTextEmptyCheck",this.questiontextEmptyCheck);

    this.typedquestionText = event.target.value;
    console.log("Check Console 46",)
    // k this.selectedQuestionMedia = this.selectedComplexity;
  }

  questionStyleChangeHandler(event: any) {
    this.questionstyleEmptyCheck = false;
   // this.typedquestionTextindex = i;

    console.log("questionStyleEmptyCheck",this.questionstyleEmptyCheck);
//Retrive Media paths from Local folder based on Style name Logic start
console.log("QUESTION STYLE ID ",this.question_stylelist.Id);
    let idSelect = event.target.value;
    console.log("Id Select ", idSelect);
    var questionStyleNameFound ="";
    for(var j = 0;j < this.question_stylelist.length; j++){

      //console.log("Quetion Category",this.Question_Sub_Category[j]);
      if(this.question_stylelist[j].Id == idSelect){
        
        console.log("Inside IF Loop");
        console.log("Printing the sub categoryyy  :",this.question_stylelist[j].Name);
        questionStyleNameFound = this.question_stylelist[j].Name;
      }

    }
    

    
    //this.mediacategorychange()
    this.selectedsubCategory = event.target.value;
   
    this.complexity.subcategory_id = this.selectedsubCategory;
    this.type.subcategory_id = this.selectedsubCategory;

    this.mediaservice.getImagePaths(questionStyleNameFound).subscribe(
      (response: any) => {
        console.log("RESPONSE.IMAGEPATHS",response);
        this.imagePaths = response;
        console.log("This .imagePaths inside upload audio video component ",this.imagePaths);
      },
      (error: any) => {
        console.error("Failed to retrieve image paths:", error);
      }
    );

    //Retrive Media paths from Local folder based on Style name Logic End





    this.auth.MCQtype().subscribe(
      data => {
        
        // this.question_typelist = data.results;
        // console.log("This.question_type_list",this.question_typelist);
  
        // this.details = true;
        // return this.question_typelist;
  
        this.question_typelist = data.results;
        console.log("Data.res inside ques cat",data.results);
        console.log("Qoestt",this.question_typelist)
      ///   if(this.firstTypeChange == false){
      ///   this.question_typelist.forEach(element => {
      ///     if(this.questionTypeCategories.includes(element.Name)){
      ///       this.filteredQuestionTypeArray.push(element)
      ///     }
          
      ///   });
      ///   this.firstTypeChange = true;
      /// }
        // this.filteredSubCategories = this.Question_Sub_Category.find(value =>
        //   this.mediaSubCategories.includes(value.Sub_Category_Name)
          
         
        // )
        this.details = true;
        //console.log("Filtertyppe",this.filteredQuestionTypes)
       //this.filteredSubCategoryArray.push(this.filteredSubCategories)
        //console.log("Filtertype arr",this.filteredQuestionTypeArray)
        return this.question_typelist;
  
  
      },
      err => {
        console.error(err);
      }
    );

    this.typedquestionStyle = event.target.value;

    console.log("Event value of question style",event.target.value);
    console.log("Selected question style",this.typedquestionStyle);

    this.typedquestionStyle = this.question_stylelist.find(style => style.Id === +event.target.value);
    
    if(this.typedquestionStyle.Name == 'video' || this.typedquestionStyle.Name == 'audio'){
      
      this.isSelectedQuestionStyle = false;
    }else{
    this.isSelectedQuestionStyle = true;
    }
    console.log("this.is selected in question style ",this.isSelectedQuestionStyle);
    console.log("Check Console 478",this.typedquestionStyle)
    // k this.selectedQuestionMedia = this.selectedComplexity;
  }

  answerBox1ChangeHandler(event: any) {
    this.answer1EmptyCheck = false;
   
    console.log("Printing answer1EmptyCheck",this.answer1EmptyCheck);

    this.typedAnswer1 = event.target.value.trim();
    console.log("Typed Answer 1 : ",this.typedAnswer1);
    
  }

  answerBox2ChangeHandler(event: any) {
    this.answer2EmptyCheck = false;
   
    console.log("Printing answer2EmptyCheck",this.answer2EmptyCheck);

    this.typedAnswer2 = event.target.value.trim();
    console.log("Typed Answer 2 : ",this.typedAnswer2);
    
    
  }

  answerBox3ChangeHandler(event: any) {
    this.answer3EmptyCheck = false;
   
    console.log("Printing answer3EmptyCheck",this.answer3EmptyCheck);

    this.typedAnswer3 = event.target.value.trim();
    console.log("Typed Answer 3 : ",this.typedAnswer3);
    
  }

  answerBox4ChangeHandler(event: any) {
    this.answer4EmptyCheck = false;
   
    console.log("Printing answer4EmptyCheck",this.answer4EmptyCheck);

    this.typedAnswer4 = event.target.value.trim();
    console.log("Typed Answer 4 : ",this.typedAnswer4);
    
  }

  answerBox5ChangeHandler(event: any) {
    this.answer5EmptyCheck = false;
   
    console.log("Printing answer5EmptyCheck",this.answer5EmptyCheck);

    this.typedAnswer5 = event.target.value.trim();
    console.log("Typed Answer 5 : ",this.typedAnswer5);
  }

  answerBox6ChangeHandler(event: any) {
    this.answer6EmptyCheck = false;
   
    console.log("Printing answer6EmptyCheck",this.answer6EmptyCheck);

    this.typedAnswer6 = event.target.value.trim();
    console.log("Typed Answer 6 : ",this.typedAnswer6);
    
  }


  
  correctAnswerChangeHandler(event: any) {
    this.correctAnswerEmptyCheck = false;
   // this.correctAnswerMismatchCheck= false;
   
    console.log("Printing correctanswerEmptyCheck",this.correctAnswerEmptyCheck);
    //console.log("Printing correctAnswerMismatchCheck",this.correctAnswerMismatchCheck);


    this.typedCorrectAnswer = event.target.value.trim();
    console.log("Typed Correct answer : ",this.typedCorrectAnswer);
    if(this.typedCorrectAnswer != this.typedAnswer1 && this.typedCorrectAnswer != this.typedAnswer2 && this.typedCorrectAnswer != this.typedAnswer3 && this.typedCorrectAnswer != this.typedAnswer4 ){
      this.correctAnswerMismatchCheck = true;
      console.log("ans 1",this.typedAnswer1);
      console.log("ans 2",this.typedAnswer2);
      console.log("ans 3",this.typedAnswer3);
      console.log("ans 4",this.typedAnswer4);
      console.log("Correct Ans ",this.typedCorrectAnswer);
      console.log("Karthikeyan A")
    }
    else{
      this.correctAnswerMismatchCheck = false;
      console.log("SWE");
    }

    console.log("Printing correctAnswerMismatchCheck 11",this.correctAnswerMismatchCheck);
    
  }


  //type changehandler
  typeChangeHandler(event: any, i: any) {
    this.typeEmptyCheck = false;

    // this.selectedtypeindex = i;

    // this.selectedtype = event.target.value;
    // console.log("Event value",event.target.value);
    // console.log("Selected type",this.selectedtype);

    // this.selectedType = this.question_typelist.find(type => type.Id === +event.target.value);
    // if(this.selectedType.Name == 'MCQS_WITH_IMAGES'){
      
    //   this.isSelectedImageType = true;
    // }else{
    //   this.isSelectedImageType = false;
    // }
    // console.log("this.is selcted",this.isSelectedImageType);

    //New Condition based on question type video and question style video
    this.selectedtype = event.target.value;
    console.log("Event value",event.target.value);
    console.log("Selected question type",this.selectedtype);

    this.selectedType = this.question_typelist.find(type => type.Id === +event.target.value);
    if(this.selectedType.Name == 'Multiple Choice' || this.selectedType.Name == 'MCQ With Free Text'){
      
      this.isSelectedQuestionType = true;
      console.log("1 Inside if condition of selected Question type ....",this.isSelectedQuestionType)
    }else{
    this.isSelectedQuestionType = false;
    console.log("2 Inside else condition of selected Question type ....",this.isSelectedQuestionType)
    }

    console.log("this.is selected",this.isSelectedQuestionType);
    console.log("The selected type name is ..... ",this.selectedType.Name)

    if(this.selectedType.Name == 'Multiple Choice'){
      this.useOfMultipleOptionsOnlyMCQ = true;
    }else{
      this.useOfMultipleOptionsOnlyMCQ = false;
    }

    if(this.selectedType.Name == 'MCQ With Free Text'){
      this.useOfMultipleOptions = true;
    }else{
      this.useOfMultipleOptions = false;
    }



    if(this.selectedType.Name == 'Comprehension With MCQ'){
      console.log("Inside if of comprehension check")
      this.isSelectedTypeEqualsComprehension = true;
      this.isSelectedTypeEqualsComprehensionForEdit = true;
      this.useOfMultipleOptions = true;
      this.displayAddCompButtonForMcq = true;
      console.log(" 1 Displaying comp button boolean ",this.displayAddCompButtonForMcq);
    }else{
      console.log("Inside else of comprehension check")
      this.isSelectedTypeEqualsComprehension = false;
      this.isSelectedTypeEqualsComprehensionForEdit = false;
      this.displayAddCompButtonForMcq = false;
      console.log(" 2 Displaying comp button boolean ",this.displayAddCompButtonForMcq);
    }

    if(this.selectedType.Name == 'Comprehension With Free Text'){
      this.isSelectedTypeEqualsComprehensionWithFreeText = true;
      this.isSelectedTypeEqualsComprehensionFTForEdit = true;
      this.displayAddCompButtonForFreeText = true;
      console.log(" 3 Displaying comp button boolean ",this.displayAddCompButtonForFreeText);
    }
    else{
      this.isSelectedTypeEqualsComprehensionWithFreeText = false;
      this.isSelectedTypeEqualsComprehensionFTForEdit = false;
      this.displayAddCompButtonForFreeText = false;
      console.log(" 4 Displaying comp button boolean ",this.displayAddCompButtonForFreeText);
    }

    if(this.selectedType.Name == 'Free Text'){
      this.isSelectedTypeEqualsFreeText = true;
    }
    else{
      this.isSelectedTypeEqualsFreeText = false;
    }

    if(this.selectedType.Name == 'VideoAnswer'){
      this.isSelectedTypeEqualsVideoAnswer = true;
    }
    else{
      this.isSelectedTypeEqualsVideoAnswer = false;
    }

    if(this.selectedType.Name == 'AudioAnswer'){
      this.isSelectedTypeEqualsAudioAnswer = true;
    }
    else{
      this.isSelectedTypeEqualsAudioAnswer = false;
    }

    if(this.selectedType.Name == 'Algorithm'){
      this.isSelectedTypeEqualsAlgorithm = true;
    }
    else{
      this.isSelectedTypeEqualsAlgorithm = false;
    }



    console.log("Question Type equals Comprehension boolean value : ",this.isSelectedTypeEqualsComprehension);
    
    console.log("Question Type equals Comprehension With Free text boolean value : ",this.isSelectedTypeEqualsComprehensionWithFreeText);

    console.log("Question Type equals VideoAnswer boolean value : ",this.isSelectedTypeEqualsVideoAnswer);

    console.log("Question Type equals Audio Answer boolean value : ",this.isSelectedTypeEqualsAudioAnswer);

    console.log("Question Type equals Algorithm boolean value : ",this.isSelectedTypeEqualsAlgorithm);


    

   // console.log("Selected Option",this.selectedtype.Name);




    this.complexity.type_id = this.selectedtype;

    this.auth.getComplexityTypes().subscribe(
      data => {
        this.Complexity = data.results;
        console.log(this.Complexity);

        // tslint:disable-next-line: prefer-for-of
        //  for (let i = 0; i < this.Complexity.length; i++) {
        //
        //   this.complexityName.push(this.Complexity[i].Complexity_Name);
        //
        // }
        this.details = true;
        return this.Complexity;
      },
      err => {
        console.error(err);
      }
    );
  }

  //subcategory changehandler
  subcategoryChangeHandler(event: any, i: any) {
  
    
    this.subCategoryEmptyCheck = false;
    this.selectedsubCategoryindex = i;
    
    
    // console.log("QUESTION SUB CATEGORY ID ",this.Question_Sub_Category.Id);
    // let idSelect = event.target.value;
    // console.log("Id Select ", idSelect);
    // var subCategoryNameFound ="";
    // for(var j = 0;j < this.Question_Sub_Category.length; j++){

    //   //console.log("Quetion Category",this.Question_Sub_Category[j]);
    //   if(this.Question_Sub_Category[j].Id == idSelect){
        
    //     console.log("Inside IF Loop");
    //     console.log("Printing the sub categoryyy  :",this.Question_Sub_Category[j].Sub_Category_Name);
    //     subCategoryNameFound = this.Question_Sub_Category[j].Sub_Category_Name;
    //   }

    // }
    

    
    // //this.mediacategorychange()
    // this.selectedsubCategory = event.target.value;
   
    // this.complexity.subcategory_id = this.selectedsubCategory;
    // this.type.subcategory_id = this.selectedsubCategory;

    // this.mediaservice.getImagePaths(subCategoryNameFound).subscribe(
    //   (response: any) => {
    //     console.log("RESPONSE.IMAGEPATHS",response);
    //     this.imagePaths = response;
    //     console.log("This .imagePaths inside upload audio video component ",this.imagePaths);
    //   },
    //   (error: any) => {
    //     console.error("Failed to retrieve image paths:", error);
    //   }
    // );

    //This one is old method
    // this.auth.type(this.type).subscribe(
    //New Approach for MCQtype
    
    
   this.auth.MCQstyle().subscribe(
    data => {
  
      this.question_stylelist = data.results;
      console.log("Data.res inside ques style",data.results);
      console.log("Quest Styleee",this.question_stylelist)
   
  if(this.firststyleclick == false){
      this.filteredStyles = this.question_stylelist.forEach(element => {
        if(this.mediaUsedNames.includes(element.Name)){
          console.log("NAme of the element ",element.Name);
          this.filteredStyleArray.push(element)
        }
      });

      this.firststyleclick = true;
    }
    
    
      this.details = true;
     
      console.log("FIltered styyle id ",this.filteredStyleArray);
      return this.filteredStyleArray;

    },
    err => {
      console.error(err);
    }
  );




    



    // this.auth.types().subscribe(
    //   data => {
    //     this.complexity = data.results;

    //     this.details = true;
    //     return this.complexity;
    //   },
    //   err => {
    //     console.error(err);
    //   }
    // );



  }
  __spreadArray(to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
      to[j] = from[i];
    return to;
  }
  

  assign_next() {
    //alert("wrong setnext")

  //  if(this.ifComprehensionArrayEdited == true){
  //   console.log("Check the comprehension array edited ",this.ifComprehensionArrayEdited);
  //   this.resetComprehensionFields();
  //   this.modalRef.close(this.modalContent)
    
  //  }

  //  this.ifComprehensionArrayEdited = false;

  
  
  console.log("Dup field arr",this.dup_fieldArray);
  console.log("Print of new Attribute ",this.newAttribute);

    console.log("Checking the Field array ",this.fieldArray);
    console.log("Checking the comprehension Array :  ",this.comprehensionArray);

console.log(" 1111 Inside first statement of assign next");
// this.fieldArray = [];
// console.log("000",this.fieldArray);

//this.fielder.push(this.newAttribute);
console.log("check 1",this.fieldArray);
//this.fieldArray.push(this.newAttribute);

console.log("1234 Field array after pushing new attribute ",this.fieldArray);
console.log("15678 Fielder after pushing new attribute ",this.fielder);
    if(this.comprehensionArray.length > 0){
      
console.log("!!! Fielder",this.fielder);
console.log("!!! Field Array",this.fieldArray);
console.log("!!! Comprehension Array ",this.comprehensionArray);
console.log("!!! SET ",this.set);


     
      console.log("222 inside comprehension condition and comprehension array length ",this.comprehensionArray.length);

      // this.newAttribute = {
      //   category: '',
      //   subcategory: '',
      //   type: '',
      //   style:'',
      //   complexity: '',
      //   questionMedia: '',
      //   questionText:'',
      //   question_text: '',
      //   question_category_id: '',
      //     question_sub_category_id :'',
      //     question_type_id:'',
      //     question_style_id:'',
      //     complexity_id: '',
      //     q_url: '',
      //     Correct_Answer:'',
      //     Answer1:'',
      //     Answer2:'',
      //     Answer3:'',
      //     Answer4:'',
      //     Answer5:'',
      //     Answer6:'',
      //     CorrectAnswer:''
          
      //   };
      //   this.fieldArray.push(this.newAttribute);
        console.log("Checking field arrrr",this.fieldArray);
      //this.fieldArray.splice(0, 1);
      //this.set.splice(0,1);
      // this.fieldArray[0].Answer1 ='';
      // this.fieldArray[0].Answer2 ='';
      // this.fieldArray[0].Answer3 ='';
      // this.fieldArray[0].Answer4 ='';
      // this.fieldArray[0].Answer5 ='';
      // this.fieldArray[0].Answer6 ='';
      // this.fieldArray[0].Correct_Answer ='';
      // this.fieldArray[0].category ='';
      // this.fieldArray[0].complexity ='';
      // this.fieldArray[0].complexity_id ='';
      // this.fieldArray[0].q_url ='';
      // this.fieldArray[0].questionMedia ='';
      // this.fieldArray[0].questionText ='';
      // this.fieldArray[0].question_category_id ='';
      // this.fieldArray[0].question_sub_category_id ='';
      // this.fieldArray[0].question_text ='';
      // this.fieldArray[0].question_type_id ='';
      // this.fieldArray[0].style ='';
      // this.fieldArray[0].subcategory ='';
      // this.fieldArray[0].type ='';
      //changed here on 14 6 2023
      this.fieldArray = []
      
      console.log("PPPP new Attribute ,",this.newAttribute);
console.log("Initial set printinggggg : ",this.set);
      console.log("After splice of FieldArray ",this.fieldArray);
      // console.log("!@#CompFieldArray before push .... ",this.compFieldArray);
      //this.compFieldArray.push(this.comprehensionArray);
      // this.__spreadArray(this.compFieldArray,this.fieldArray);
      // console.log("!@#CompFieldArray after push .... ",this.compFieldArray);
      // this.fielder.push(this.compFieldArray);
      // console.log("1871 after push into fielder ",this.fielder);
      

      console.log("Comprehension Arr inside IF",this.comprehensionArray);
      this.__spreadArray(this.fieldArray,this.comprehensionArray);
      console.log("@#$Fielder arr printing ",this.fielder);
       console.log("Field arr inside IF",this.fieldArray);
      console.log("Before push of SET : ",this.set);
      //this.set.splice(-1,2);
      //this.set = [];
      console.log("SET Printing after splice.... ",this.set)
      this.__spreadArray(this.set,this.fieldArray);
      //this.set.push(this.fieldArray)
      console.log("SET Printing .... ",this.set)
      this.comprehensionArray = [];
      this.getTableCountForComprehension = 0;
     // this.__spreadArray(this.set,this.comprehensionArray);
     // console.log("After push set inside IF : ",this.set);
    }

    else{



     this.fieldArray = []
     console.log("Print of set",this.set);
     this.set = [];
     console.log("Print of set after emptying ",this.set);

    // this.__spreadArray(this.fieldArray,this.comprehensionArray);
    //   console.log("43",this.fieldArray);
    // this.__spreadArray(this.set,this.comprehensionArray);
    // console.log("44",this.set);
    // console.log("Fielder array before pushing comp ",this.fielder)
    console.log("434343 Initial fieldarray before push ",this.fieldArray);
    console.log("333 printing the new attribute ",this.newAttribute);
    //this.fielder.push(this.newAttribute);
   this.fieldArray.push(this.newAttribute);
   
   console.log("454545 fieldarray after push ",this.fieldArray);

   this.field_push = this.fieldArray.length - 1
    console.log("Field push console ",this.field_push);
    this.__spreadArray(this.set,this.fieldArray);
   // this.set.push(this.fieldArray[this.field_push])
///987654321
 // if(!this.questiontextEmptyCheck && !this.answer1EmptyCheck && !this.answer2EmptyCheck && !this.answer3EmptyCheck && !this.answer4EmptyCheck && !this.correctAnswerEmptyCheck && !this.correctAnswerMismatchCheck){

  // this.__spreadArray(this.set,this.fieldArray)
 

   console.log("SET ARRRR AFTER PUSH INSIDE ELSE ",this.set);
   //this.removeDuplicates(this.set);
   console.log("Set Arr afterrrrrrr");
    console.log("5544 After fieldArray after attribute push ",this.fieldArray);
    //}
  }
    //this.fielder.push(this.newAttribute);
   // this.delete_counter = 1;
    if (this.delete_counter === 1) {
      // this.fieldArray = []
      console.log("444 inside delete counter condition")
      console.log("Before push of new Attribute into fielderr 4.5",this.fielder);
      
      //this.set.push(this.fieldArray[this.field_push])
     // this.fielder.push(this.newAttribute) kkk
      console.log("555 After FIELDER push inside the delete counter condition ",this.fielder);

      //this.fielder.concat(this.comprehensionArray);
     // this.__spreadArray(this.fielder,this.comprehensionArray)
     // console.log("Comp pushed array fielder",this.fielder);

     // console.log("F PUSH 4",this.fielder);
      //this.fieldArray.push(this.newAttribute)
    }
    console.log("Check if last index deleted : ",this.lastindex_deleted);
    if (this.lastindex_deleted === true) {
      console.log("Inside lastindex_deleted TRUE Condition",this.lastindex_deleted);
      this.fieldArray.push(this.newAttribute)
      //console.log("FA PUSH 4",this.fieldArray);
      console.log("666 After FIELD ARRAY  push inside the last index deleted condition ",this.fieldArray);
    }

    this.disableDeleteButton = false

    console.log("777 No Conditions in the code printing FieldARRAY", this.fieldArray)
    console.log("888 fieldArrayLen*****   ", this.fieldArray.length)

    this.lastindex_deleted = false
    this.delete_counter = 0

    
    // this.field_push = this.fieldArray.length - 1
    // console.log("Field push console ",this.field_push);
    
    // this.set.push(this.fieldArray[this.field_push]) // check kar
  
   //this.__spreadArray(this.set,this.fieldArray)
   console.log("Printing this.set length ",this.set.length);
  //  if(this.isSelectedTypeEqualsComprehension){
  //   this.set = [];
  //   console.log("Printing set at first",this.set);
  //  }
    console.log("Printing set at first",this.set);
    console.log("Check set check printing ",this.check_set);
    console.log("Print Comparr at first",this.comprehensionArray);
    // this.__spreadArray(this.set,this.fieldArray)

  //  this.set.push(this.fieldArray[this.field_push]) HEREN
    console.log("999 Printing the set after pushingt fieldArray into it ",this.set);
    this.setnextcounter = this.setnextcounter + 1


    this.validation_fail = 0



    for (let i = 0; i <= this.fieldArray.length - 1; i++) {

      console.log("Inside the loop ........")
    
      if (this.fieldArray[i].category === '') {
        this.categoryEmptyCheck = true;
        // alert("Enter Correct Question Set details")
      }
      else {
        this.categoryEmptyCheck = false;
      }
      if (this.fieldArray[i].subcategory === '') {
        this.subCategoryEmptyCheck = true;
        // alert("Enter Correct Question Set details")
      }
      else {
        this.subCategoryEmptyCheck = false;

      }
      if (this.fieldArray[i].type === '') {
        this.typeEmptyCheck = true;
      }
      else {
        this.typeEmptyCheck = false;
      }
      if (this.fieldArray[i].style === '') {
        this.questionstyleEmptyCheck = true;
      }
      else {
        this.questionstyleEmptyCheck = false;
      }
      if (this.fieldArray[i].complexity === '') {
        
        this.complexityEmptyCheck = true;
      }
      else {
        this.complexityEmptyCheck = false;
      }

      if(this.fieldArray[i].questionText === null || this.fieldArray[i].questionText ===''){
        this.questiontextEmptyCheck = true;
        console.log("questiontextEmpty check true");
      }
      else{
        this.questiontextEmptyCheck = false;
      }
      if(this.fieldArray[i].questionMedia ===''){
        this.questionMediaEmptyCheck = true;
      }
      else{
        this.questionMediaEmptyCheck = false;
      }



   //   if(this.fieldArray[i].type === "10"){
console.log("Checking whether Selected type Equals Comprehension with free text : ",this.isSelectedTypeEqualsComprehensionWithFreeText)
      if(this.fieldArray[i].Answer1.trim() === null || this.fieldArray[i].Answer1.trim() ===''){
        if(this.isSelectedTypeEqualsComprehensionWithFreeText || this.isSelectedTypeEqualsFreeText || this.isSelectedTypeEqualsVideoAnswer || this.isSelectedTypeEqualsAudioAnswer || this.isSelectedTypeEqualsAlgorithm){
          this.answer1EmptyCheck = false;
        }else{
        this.answer1EmptyCheck = true;
        console.log("Answer 1 Empty check true");}
      }
      else{
        this.answer1EmptyCheck = false;
      }

      if(this.fieldArray[i].Answer2.trim() === null || this.fieldArray[i].Answer2.trim() ===''){
        if(this.isSelectedTypeEqualsComprehensionWithFreeText || this.isSelectedTypeEqualsFreeText || this.isSelectedTypeEqualsVideoAnswer || this.isSelectedTypeEqualsAudioAnswer || this.isSelectedTypeEqualsAlgorithm){
          this.answer2EmptyCheck = false;
        }else{
        this.answer2EmptyCheck = true;
        console.log("Answer 2 Empty check true");}
      }
      else{
        this.answer2EmptyCheck = false;
      }

      if(this.fieldArray[i].Answer3.trim() === null || this.fieldArray[i].Answer3.trim() ===''){
        if(this.isSelectedTypeEqualsComprehensionWithFreeText || this.isSelectedTypeEqualsFreeText || this.isSelectedTypeEqualsVideoAnswer || this.isSelectedTypeEqualsAudioAnswer || this.isSelectedTypeEqualsAlgorithm){
          this.answer3EmptyCheck = false;
        }else{
        this.answer3EmptyCheck = true;
        console.log("Answer 3 Empty check true");}
      }
      else{
        this.answer3EmptyCheck = false;
      }

      if(this.fieldArray[i].Answer4.trim() === null || this.fieldArray[i].Answer4.trim() ===''){
        if(this.isSelectedTypeEqualsComprehensionWithFreeText || this.isSelectedTypeEqualsFreeText || this.isSelectedTypeEqualsVideoAnswer || this.isSelectedTypeEqualsAudioAnswer || this.isSelectedTypeEqualsAlgorithm){
          this.answer4EmptyCheck = false;
        }else{
        this.answer4EmptyCheck = true;
        console.log("Answer 4 Empty check true");}
      }
      else{
        this.answer4EmptyCheck = false;
      }

      if(this.fieldArray[i].Correct_Answer.trim() === null || this.fieldArray[i].Correct_Answer.trim() ===''){
        if(this.isSelectedTypeEqualsComprehensionWithFreeText || this.isSelectedTypeEqualsFreeText || this.isSelectedTypeEqualsVideoAnswer || this.isSelectedTypeEqualsAudioAnswer || this.isSelectedTypeEqualsAlgorithm){
          this.correctAnswerEmptyCheck = false;
        }else{
        this.correctAnswerEmptyCheck = true;
        console.log("Correct Answer Empty check true");}
      }
      else{
        this.correctAnswerEmptyCheck = false;
      }

      

      if(this.fieldArray[i].Correct_Answer.trim() != this.fieldArray[i].Answer1.trim() && this.fieldArray[i].Correct_Answer.trim() != this.fieldArray[i].Answer2.trim() && this.fieldArray[i].Correct_Answer.trim() != this.fieldArray[i].Answer3.trim() && this.fieldArray[i].Correct_Answer.trim() != this.fieldArray[i].Answer4.trim() ){
        if(this.isSelectedTypeEqualsComprehensionWithFreeText || this.isSelectedTypeEqualsFreeText || this.isSelectedTypeEqualsVideoAnswer || this.isSelectedTypeEqualsAudioAnswer || this.isSelectedTypeEqualsAlgorithm){
          this.correctAnswerMismatchCheck = false;
        }else{
        this.correctAnswerMismatchCheck = true;
        console.log("Inside If of correctAnswerMismatch");}
      }
      else{
        this.correctAnswerMismatchCheck = false;
        console.log("Inside else of correctAnswerMismatch");
      }

      // if(this.answer1EmptyCheck == true && this.answer2EmptyCheck == true && this.answer3EmptyCheck == true && this.answer4EmptyCheck == true && this.correctAnswerEmptyCheck == true){
      //   this.uniqueOptionNotAssigned = false;
      //   console.log("KKKSWE");
      // }


      console.log("@@@ Answer 1 ",this.fieldArray[i].Answer1)
      console.log("@@@ Answer 2 ",this.fieldArray[i].Answer2)
      console.log("@@@ Answer 3 ",this.fieldArray[i].Answer3)
      console.log("@@@ Answer 4 ",this.fieldArray[i].Answer4)
      console.log("@@@ Correct Answer  ",this.fieldArray[i].Correct_Answer);
      if(this.fieldArray[i].Answer1.trim() == this.fieldArray[i].Answer2.trim() || this.fieldArray[i].Answer1.trim() == this.fieldArray[i].Answer3.trim() || this.fieldArray[i].Answer1.trim() == this.fieldArray[i].Answer4.trim() || this.fieldArray[i].Answer2.trim() == this.fieldArray[i].Answer3.trim() || this.fieldArray[i].Answer2.trim() == this.fieldArray[i].Answer4.trim() || this.fieldArray[i].Answer3.trim() == this.fieldArray[i].Answer4.trim()){
        if(this.isSelectedTypeEqualsAlgorithm ||this.isSelectedTypeEqualsAudioAnswer ||this.isSelectedTypeEqualsVideoAnswer||this.isSelectedTypeEqualsComprehensionWithFreeText || this.isSelectedTypeEqualsFreeText){
          this.uniqueOptionNotAssigned = false;
          console.log("2222")
        }else{
        this.uniqueOptionNotAssigned = true;
        console.log("2223")
        }
      }
      else{
        this.uniqueOptionNotAssigned = false;
        console.log("2224")
      }
   // } here


      if (( (this.categoryEmptyCheck === false) && (this.typeEmptyCheck === false) )) {
       console.log("1")
    if ((this.subCategoryEmptyCheck === false) && (this.questionMediaEmptyCheck === false)) {
         console.log("2");
         if ((this.questiontextEmptyCheck === false) && (this.questionstyleEmptyCheck == false))  {
           console.log("3");
            console.log("1",this.answer1EmptyCheck);
            console.log("2",this.answer2EmptyCheck);
            console.log("3",this.answer3EmptyCheck);
            console.log("4",this.answer4EmptyCheck);
            console.log("5",this.answer5EmptyCheck);
            console.log("6",this.answer6EmptyCheck);
            console.log("CA",this.correctAnswerEmptyCheck);
            console.log("CAM",this.correctAnswerMismatchCheck);
            console.log("Unique option Mismatch ",this.uniqueOptionNotAssigned);
            console.log("Complexity empty check check ",this.complexityEmptyCheck);
           if ((this.complexityEmptyCheck === false)) {
    if(this.answer1EmptyCheck === false && this.answer2EmptyCheck === false && this.answer3EmptyCheck === false && this.answer4EmptyCheck === false && this.correctAnswerMismatchCheck === false && this.uniqueOptionNotAssigned === false){

              console.log("4");
               this.validation_fail = this.validation_fail + 1
           }
          }

      }
       }


     }
    } 
    //this.complexityEmptyCheck = false;  //check kar

    console.log(" 10101010 This Validation fail  and Field array Length ",this.validation_fail,this.fieldArray.length);

    if (this.validation_fail == this.fieldArray.length) {
      console.log("0 check fielder ",this.fielder);
      this.check_media_configuration()
     }
    else {
      console.log("check fielder 1 ",this.fielder);
      console.log("Inside set Next else ",this.fieldArray);
      this.fieldArray.splice(-1, 1);
      console.log("Inside set Next else 2 ",this.fieldArray);
      console.log("987 New attribute before pushing into field Array  ",this.newAttribute);
      //this.fielder.splice(-1,1);
      this.fieldArray.push(this.newAttribute)
      console.log("11 11 11 FieldArray ELse of Validation push ",this.fieldArray);
      console.log("check fielder 2 ",this.fielder);

      //console.log("FA push 5",this.fieldArray);
    }

   // console.log("F PUSH 5 ",this.fielder);
   console.log("12 12 12 Just Printing Fielder",this.fielder);
  //here }
  
  
  }


//Old method has bugs
//   check_media_configuration() {
//     console.log("Inside Check set Config")
//     //alert("wrong")
//     this.duplicate_set_config = false;
//     console.log("Field array length printing ...." ,this.fieldArray.length);
//     this.field_push = this.fieldArray.length - 1
//     console.log("Field_push ::::::",this.field_push);


//    this.check_set.push(this.fieldArray[this.field_push])
//     console.log("check_set",this.check_set)
//     console.log("Check set Length",this.check_set.length);
//    // this.modalRef.close(this.modalContent)   //Changed here
//     this.lastelem = this.check_set.length - 1;
//     console.log("Printing the last elem ::::",this.lastelem);
//     if (this.check_set.length > 1) {
//       console.log("Inside 43");
      

//       for (var i = 0; i < this.check_set.length - 1; i++) {
//         if(i == 0){
//         this.getNameForQuestionFields(this.check_set[i]);
//         }
//         console.log("Inside for loop of check set config");
//         console.log("check_set[this.lastelem] .... ",this.check_set[this.lastelem])
//         console.log("check_set[i] .... ",this.check_set[i])
// console.log("CONSOLE CONSOLE CONSOLE");
// console.log("Question Media :",this.check_set[this.lastelem].questionMedia,this.check_set[i].questionMedia)
// console.log("Category :",this.check_set[this.lastelem].category,this.check_set[i].category)
// console.log("Sub category :",this.check_set[this.lastelem].subcategory,this.check_set[i].subcategory)
// console.log("Complexity :",this.check_set[this.lastelem].complexity,this.check_set[i].complexity)
// console.log("Type :",this.check_set[this.lastelem].type,this.check_set[i].type) 
// if (this.check_set[this.lastelem].questionMedia == this.check_set[i].questionMedia && this.check_set[this.lastelem].category == this.check_set[i].category && this.check_set[this.lastelem].subcategory == this.check_set[i].subcategory && this.check_set[this.lastelem].type == this.check_set[i].type && this.check_set[this.lastelem].complexity == this.check_set[i].complexity) {
//   if(this.check_set[this.lastelem].questionText == this.check_set[i].questionText && this.check_set[this.lastelem].Answer1 == this.check_set[i].Answer1 && this.check_set[this.lastelem].Answer2 == this.check_set[i].Answer2 && this.check_set[this.lastelem].Answer3 == this.check_set[i].Answer3 && this.check_set[this.lastelem].Answer4 == this.check_set[i].Answer4 && this.check_set[this.lastelem].Correct_Answer == this.check_set[i].Correct_Answer){
// //condition inside if this.check_set[this.lastelem].questionMedia == this.check_set[i].questionMedia && this.check_set[this.lastelem].category == this.check_set[i].category && this.check_set[this.lastelem].subcategory == this.check_set[i].subcategory && this.check_set[this.lastelem].type == this.check_set[i].type && this.check_set[this.lastelem].complexity == this.check_set[i].complexity
//           console.log("Inside 44")

//           console.log("Duplicate detected");

//           this.duplicate_set_config = true;
//           console.log("Check check 1");
//           Swal.fire({
//             title: 'Alert',
//             text: 'Duplicate Question has been Assigned',
//             icon: 'warning',
//             showCancelButton: false,
//             confirmButtonText: 'OK'
//           }).then((result) => {
//             if (result.isConfirmed) {
//             }
//           })
//           console.log("TTHHIISS set print here",this.set);
//           this.getNameForQuestionFields(this.set);
//           this.check_set.splice(-1, 1);
//         }
//       }
//       }
//       //this.org_questioncount == false;
//       if (this.duplicate_set_config != true){   // && this.org_questioncount == false){    // && this.org_questioncount == false) {
//         console.log("Inside IF of 45 ");

//         console.log("Field Array Display in If at last ......",this.fieldArray);

//         this.getTempRowData()
//        // this.getsectionid()
//        console.log("checking if comprehension ",this.isSelectedTypeEqualsComprehension);
//       //  if(this.isSelectedTypeEqualsComprehension){
        
//       //  this.getNameForQuestionFields(this.set)
//       //  }else{
//       //  this.getTabledata()
//       //  }
//       console.log("47 printing this.set before pushing in the new func ...",this.set);
//       console.log("48 printing this.checkset before pushing in the new func ...",this.check_set);
//        this.getNameForQuestionFields(this.set)
//         //this.check_set =[];
//         console.log("49",this.check_set);
//        this.fieldArray = [];
//        console.log("Model Content ",this.modalContent)
//        this.modalRef.close(this.modalContent)
//        console.log("Closed");
//       }

//     }
//     else {
//       // this.org_questioncount == false;   //Changed here
      

//         console.log("Inside else IF 46");
// console.log("checking the fielderr after 46",this.fielder);
//         this.getTempRowData()
//         console.log("TTHIS FFIELDER INSIDE ELDE",this.fielder);

//         // this.fieldArray.push(this.newAttribute);
//        // this.getsectionid()

//        console.log("Field Array Display in Else at last ......",this.fieldArray);

//        console.log("checking if comprehension or not ",this.isSelectedTypeEqualsComprehension);
//       //  if(this.isSelectedTypeEqualsComprehension){
        
//       //  this.getNameForQuestionFields(this.set)
//       //  }else{
        
//       //  this.getTabledata()
//       //  }
//       console.log("786 SET P",this.set);
//       //Changed the set as check_set
//       console.log("9870 Check",this.isSelectedTypeEqualsComprehension);

    
//       if(this.isSelectedTypeEqualsComprehension == true){
//         console.log("IIIIIIIII");
//         this.getNameForQuestionFields(this.set)
//       }else{
     
//         console.log("ooooooooo");
//        this.getTabledata()
//       }
//      // this.getNameForQuestionFields(this.check_set)
//        this.fieldArray = [];
//        console.log("Model Content ",this.modalContent)
//         this.modalRef.close(this.modalContent)
//         console.log("Closed");
      

//     }
//   }

//Server pushed method
check_media_configuration() {
  console.log("Inside Check set Config")
  //alert("wrong")
  this.duplicate_set_config = false;
  console.log("Field array length printing ...." ,this.fieldArray.length);
  this.field_push = this.fieldArray.length - 1
  console.log("Field_push ::::::",this.field_push);


 this.check_set.push(this.fieldArray[this.field_push])
  console.log("check_set",this.check_set)
  console.log("Check set Length",this.check_set.length);
 // this.modalRef.close(this.modalContent)   //Changed here
  this.lastelem = this.check_set.length - 1;
  console.log("Printing the last elem ::::",this.lastelem);
  if (this.check_set.length > 1) {
    console.log("Inside 43");
    

    for (var i = 0; i < this.check_set.length - 1; i++) {
      // if(i == 0){
      // this.getNameForQuestionFields(this.check_set[i]);
      // }
      console.log("Inside for loop of check set config");
      console.log("check_set[this.lastelem] .... ",this.check_set[this.lastelem])
      console.log("check_set[i] .... ",this.check_set[i])
console.log("CONSOLE CONSOLE CONSOLE");
console.log("Question Media :",this.check_set[this.lastelem].questionMedia,this.check_set[i].questionMedia)
console.log("Category :",this.check_set[this.lastelem].category,this.check_set[i].category)
console.log("Sub category :",this.check_set[this.lastelem].subcategory,this.check_set[i].subcategory)
console.log("Complexity :",this.check_set[this.lastelem].complexity,this.check_set[i].complexity)
console.log("Type :",this.check_set[this.lastelem].type,this.check_set[i].type) 
if (this.check_set[this.lastelem].questionMedia == this.check_set[i].questionMedia && this.check_set[this.lastelem].category == this.check_set[i].category && this.check_set[this.lastelem].subcategory == this.check_set[i].subcategory && this.check_set[this.lastelem].type == this.check_set[i].type && this.check_set[this.lastelem].complexity == this.check_set[i].complexity) {
if(this.check_set[this.lastelem].questionText == this.check_set[i].questionText && this.check_set[this.lastelem].Answer1 == this.check_set[i].Answer1 && this.check_set[this.lastelem].Answer2 == this.check_set[i].Answer2 && this.check_set[this.lastelem].Answer3 == this.check_set[i].Answer3 && this.check_set[this.lastelem].Answer4 == this.check_set[i].Answer4 && this.check_set[this.lastelem].Correct_Answer == this.check_set[i].Correct_Answer){
//condition inside if this.check_set[this.lastelem].questionMedia == this.check_set[i].questionMedia && this.check_set[this.lastelem].category == this.check_set[i].category && this.check_set[this.lastelem].subcategory == this.check_set[i].subcategory && this.check_set[this.lastelem].type == this.check_set[i].type && this.check_set[this.lastelem].complexity == this.check_set[i].complexity
        console.log("Inside 44")

        console.log("Duplicate detected");

        this.duplicate_set_config = true;
        console.log("Check check 1");
        Swal.fire({
          title: 'Alert',
          text: 'Duplicate Question has been Assigned',
          icon: 'warning',
          showCancelButton: false,
          confirmButtonText: 'OK'
        }).then((result) => {
          if (result.isConfirmed) {
          }
        })
        console.log("TTHHIISS set print here",this.set);
        //this.getNameForQuestionFields(this.set);
        this.check_set.splice(-1, 1);
      }
    }
    }
    //this.org_questioncount == false;
    if (this.duplicate_set_config != true){   // && this.org_questioncount == false){    // && this.org_questioncount == false) {
      console.log("Inside IF of 45 ");

      console.log("Field Array Display in If at last ......",this.fieldArray);

      this.getTempRowData()
     // this.getsectionid()
     console.log("checking if comprehension ",this.isSelectedTypeEqualsComprehension);
    //  if(this.isSelectedTypeEqualsComprehension){
      
    //  this.getNameForQuestionFields(this.set)
    //  }else{
    //  this.getTabledata()
    //  }
    console.log("47 printing this.checkset before pushing in the new func ...",this.check_set);

    console.log("47 printing this.set before pushing in the new func ...",this.set);
      //this.getNameForQuestionFields(this.set)

     this.fieldArray = [];
     console.log("Model Content ",this.modalContent)
     this.modalRef.close(this.modalContent)
     console.log("Closed");
    }

    this.getNameForQuestionFields(this.set)

  }
  else {
    // this.org_questioncount == false;   //Changed here
    

      console.log("Inside else IF 46");

      this.getTempRowData()
      console.log("TTHIS FFIELDER INSIDE ELDE",this.fielder);

      // this.fieldArray.push(this.newAttribute);
     // this.getsectionid()

     console.log("Field Array Display in Else at last ......",this.fieldArray);

     console.log("checking if comprehension or not ",this.isSelectedTypeEqualsComprehension);
    //  if(this.isSelectedTypeEqualsComprehension){
      
    //  this.getNameForQuestionFields(this.set)
    //  }else{
      
    //  this.getTabledata()
    //  }
    console.log("786 SET P",this.set);
    // if(this.isSelectedTypeEqualsComprehension == true){
    //           console.log("IIIIIIIII");
    //           this.getNameForQuestionFields(this.check_set)
    //         }else{
           
    //           console.log("ooooooooo");
    //           this.getNameForQuestionFields(this.set)
    //         }
    this.getNameForQuestionFields(this.set)
     this.fieldArray = [];
     console.log("Model Content ",this.modalContent)
      this.modalRef.close(this.modalContent)
      console.log("Closed");
    

  }
}
  

  //  getTabledata() {

  //       console.log("this.ged sub",this.set);
  //       const currentDomain = this.locationStrategy.getBaseHref() + this.document.location.origin;
  //       console.log("Curent domaiiiinnnnnn", currentDomain);
  //       this.qs.gettabledata(this.set).subscribe(
    
  //         (data) => {
    
    
  // //  this.fielder.splice(0,1);


  //     // this.fielder[0].Answer1 ='';
  //     // this.fielder[0].Answer2 ='';
  //     // this.fielder[0].Answer3 ='';
  //     // this.fielder[0].Answer4 ='';
  //     // this.fielder[0].Answer5 ='';
  //     // this.fielder[0].Answer6 ='';
  //     // this.fielder[0].Correct_Answer ='';
  //     // this.fielder[0].category ='';
  //     // this.fielder[0].complexity ='';
  //     // this.fielder[0].complexity_id ='';
  //     // this.fielder[0].q_url ='';
  //     // this.fielder[0].questionMedia ='';
  //     // this.fielder[0].questionText ='';
  //     // this.fielder[0].question_category_id ='';
  //     // this.fielder[0].question_sub_category_id ='';
  //     // this.fielder[0].question_text ='';
  //     // this.fielder[0].question_type_id ='';
  //     // this.fielder[0].style ='';
  //     // this.fielder[0].subcategory ='';
  //     // this.fielder[0].type ='';

  //     console.log("DATTTA" , data);
    
  //   console.log("CHECK SET LENGTH INSIDE GETTABLE DATA",this.check_set.length);

  //   //this.check_set.length = 2;
  //         this.gettablecount = this.check_set.length - 1
    
  //         console.log("gettabledata",data.results)
    
  //         console.log("gettablecount",this.gettablecount)
    
  //         console.log("Fielder print check ",this.fielder);
    
    
  //           if(data.results)
    
  //           {
    
    
    
    
  //           console.log("Data.res",data.results);
    
  //           this.fielder[this.gettablecount].question_category_id = this.set[0].category
    
  //           this.fielder[this.gettablecount].question_sub_category_id = this.set[0].subcategory
    
  //           this.fielder[this.gettablecount].question_type_id = this.set[0].type

  //           this.fielder[this.gettablecount].question_style_id = this.set[0].style
    
  //           this.fielder[this.gettablecount].complexity_id = this.set[0].complexity
    
  //   //         this.fielder[this.gettablecount].q_url = `/assets/${data.results[0].Sub_Category_Name.toLowerCase()}/${this.set[0].questionMedia}`


  //          this.fielder[this.gettablecount].q_url = `${currentDomain}/uploads/${data.results[0].Sub_Category_Name.toLowerCase()}/${this.set[0].questionMedia}`

  //           this.fielder[this.gettablecount].Answer1 = this.set[0].Answer1
  //           console.log("P THIS set",this.set);
  //           this.fielder[this.gettablecount].Answer2 = this.set[0].Answer2
  //           this.fielder[this.gettablecount].Answer3 = this.set[0].Answer3

  //           this.fielder[this.gettablecount].Answer4 = this.set[0].Answer4

  //           this.fielder[this.gettablecount].Answer5 = this.set[0].Answer5

  //           this.fielder[this.gettablecount].Answer6 = this.set[0].Answer6

  //           this.fielder[this.gettablecount].Correct_Answer = this.set[0].Correct_Answer


    
    
  //           this.fielder[this.gettablecount].category = data.results[0].Category_Name
    
  //           this.fielder[this.gettablecount].subcategory = data.results[0].Sub_Category_Name
    
  //           this.fielder[this.gettablecount].questionText = this.set[0].questionText
    
  //           this.fielder[this.gettablecount].type = data.results[0].Name
  //           this.fielder[this.gettablecount].style = data.results[0].Style_Name

    
  //           this.fielder[this.gettablecount].questionMedia = this.set[0].questionMedia
    
  //           this.fielder[this.gettablecount].complexity = data.results[0].Complexity_Name

    
  //          
    
  //           // this.fielder[this.gettablecount].question_category_id = this.set[0].category
    
  //           // this.fielder[this.gettablecount].question_sub_category_id = this.set[0].subcategory
    
  //           // this.fielder[this.gettablecount].question_type_id = this.set[0].type
    
  //           // this.fielder[this.gettablecount].complexity_id = this.set[0].complexity
    
  //           // this.fielder[this.gettablecount].q_url = `/assets/${data.results[0].Sub_Category_Name}/${this.set[0].questionMedia}`
    
    
    
    
    
  //          
    
  //          
    
  //           this.gettablecount = this.gettablecount + 1
    
  //           this.fielder.push(this.newAttribute)


  //         // this.__spreadArray(this.fielder,this.comprehensionArray)
           
  //           // this.fielder.concat(...(this.comprehensionArray))
    
  //           console.log("Printing fielder after push of normal type question array",this.fielder);
    
  //           this.fielder_last_elem = this.fielder.length - 2
    
  //           console.log("FIELDER_LAST_ELEM ",this.fielder_last_elem);
    
  //           for (var i = 0; i < this.fielder.length - 2; i++) {
    
  //             if (this.fielder[this.fielder_last_elem] == this.fielder[i]) {
    
  //               this.fielder.splice(this.fielder_last_elem, 1)
    
  //             }
    
  //           }
    
  //         }
    
    
    
    
  //        
    
    
    
    
  //         console.log("F PUSH 7",this.fielder);
    
  //         },
    
  //         err => {
    
  //           console.error(err);
    
  //         }
    
  //       );


  
    
  //     }


  // getsectionid(){
  //   if(this.fielder[this.gettablecount].section == null)
  //   {
  //     this.qs.getsectionid(this.set).subscribe(
  //       (data) => {

  //         this.gettablecount = this.check_set.length -1
  //         this.fielder[this.gettablecount].section = data.results[0].insertId
  //         console.log(this.fielder[this.gettablecount].section);
  //       })
  //   }
  // }


  addComprehensionQuestion(){
    console.log("@@@ Fielder",this.fielder);
console.log("@@@ Field Array",this.fieldArray);
console.log("@@@ Comprehension Array ",this.comprehensionArray);
console.log("@@@ SET ",this.set);

    console.log("Printing the fielder ini 010 ",this.fielder)
    console.log("dup_fieldArray",this.dup_fieldArray)

    console.log("New compp atttr",this.newComprehensionAttributes);

//     if(this.fieldArray.length >= 2){
// //this.fieldArray = [];
// console.log("Before splicing in the comp func ...",this.fieldArray);
// this.fieldArray.splice(0,1);
// console.log("After Splicing in the fieldArray ...",this.fieldArray);
//     }
    
//console.log("Checking Field array after emptying....",this.fieldArray);
// this.assign_next_for_Comprehension();
console.log("Comprehension array length %%%%% ",this.comprehensionArray.length)
console.log("Ini comp arr",this.comprehensionArray);
  // this.newComprehensionAttributes = {
  //   // questionTextOfComprehension:'',
  //   // comprehensionAnswer1:'',
  //   // comprehensionAnswer2:'',
  //   // comprehensionAnswer3:'',
  //   // comprehensionAnswer4:'',
  //   // comprehensionAnswer5:'',
  //   // comprehensionAnswer6:'',
  //   // comprehensionCorrectAnswer:'',
  //   Answer1:"",
  //   Answer2:"",
  //   Answer3:"",
  //   Answer4:"",
  //   Answer5:"",
  //   Answer6:"",
  //   CorrectAnswer:"",
  //   Correct_Answer:"",
  //   category:"",
  //   complexity:"",
  //   complexity_id:"",
  //   q_url:"",
  //   questionMedia:"",
  //   questionText:"",
  //   question_category_id:"",
  //   question_style_id:"",
  //   question_sub_category_id:"",
  //   question_text:"",
  //   question_type_id:"",
  //   style:"",
  //   subcategory:"",
  //   type:"",
  // }

 // this.fieldArray = [];
  console.log("FIelderrr Array",this.fieldArray);
  console.log("Printing initial Comprehension Array....",this.comprehensionArray);
  //if(this.comprehensionArray.length <= 1){

  console.log("New Comprehension ATrributes ....",this.newComprehensionAttributes);
  if (this.cardopen > 1) {
   // this.comprehensionArray = this.dup_fieldArray;
   console.log("Duplicate ffield aarrrr",this.dup_fieldArray);
    this.fieldArray = this.dup_fieldArray
   // this.comprehensionArray = [];
   // this.comprehensionArray = this.dup_comprehensionArray;
   this.comprehensionArray.push(this.newComprehensionAttributes);
   this.initializeComprehensionAttributes();
    //this.__spreadArray(this.comprehensionArray,this.newComprehensionAttributes)
    
    console.log("@@@@@ Comprehension array print ",this.comprehensionArray);

  }else{
    
  this.comprehensionArray.push(this.newComprehensionAttributes);
  this.initializeComprehensionAttributes();
  console.log("#### Comprehension Array printt ",this.comprehensionArray);
  }
 // }

    
  console.log("Inside the add Comprehension question Comprehension Pushed array",this.comprehensionArray);

  for(var i = 0; i<this.fieldArray.length;i++){
    
    if(this.fieldArray[i].questionText == ''){
      console.log("Check 0");
      this.questiontextEmptyCheck = true;
    }
    else{
      this.questiontextEmptyCheck = false;
    }

    if(this.fieldArray[i].Answer1.trim() == ''){
      console.log("Check 1");
      if(this.isSelectedTypeEqualsComprehensionWithFreeText){
        this.answer1EmptyCheck = false;
      }else{
      this.answer1EmptyCheck = true;
      }
    }
    else{
      this.answer1EmptyCheck = false;
    }

    if(this.fieldArray[i].Answer2.trim() == ''){
      console.log("Check 2");
      if(this.isSelectedTypeEqualsComprehensionWithFreeText){
        this.answer2EmptyCheck = false;
      }else{
      this.answer2EmptyCheck = true;
      }
    }
    else{
      this.answer2EmptyCheck = false;
    }

    if(this.fieldArray[i].Answer3.trim() == ''){
      console.log("Check 3");
      if(this.isSelectedTypeEqualsComprehensionWithFreeText){
        this.answer3EmptyCheck = false;
      }else{
      this.answer3EmptyCheck = true;
      }
    }
    else{
      this.answer3EmptyCheck = false;
    }

    if(this.fieldArray[i].Answer4.trim() == ''){
      console.log("Check 4");
      if(this.isSelectedTypeEqualsComprehensionWithFreeText){
        this.answer4EmptyCheck = false;
      }else{
      this.answer4EmptyCheck = true;
      }
    }
    else{
      this.answer4EmptyCheck = false;
    }

    if(this.fieldArray[i].Correct_Answer.trim() == ''){
      console.log("Check CA");
      if(this.isSelectedTypeEqualsComprehensionWithFreeText){
        this.correctAnswerEmptyCheck = false;
      }else{
      this.correctAnswerEmptyCheck = true;
      }
    }
    else{
      this.correctAnswerEmptyCheck = false;
    }

    if(this.fieldArray[i].Correct_Answer.trim() != this.fieldArray[i].Answer1.trim() && this.fieldArray[i].Correct_Answer.trim() != this.fieldArray[i].Answer2.trim() && this.fieldArray[i].Correct_Answer.trim() != this.fieldArray[i].Answer3.trim() && this.fieldArray[i].Correct_Answer.trim() != this.fieldArray[i].Answer4.trim() ){
      if(this.isSelectedTypeEqualsComprehensionWithFreeText){
        this.correctAnswerMismatchCheck = false;
      }else{
      this.correctAnswerMismatchCheck = true;
      }
      console.log("Inside If of correctAnswerMismatch");
    }
    else{
      this.correctAnswerMismatchCheck = false;
      console.log("Inside else of correctAnswerMismatch");
    }

    if(this.fieldArray[i].Answer1.trim() === this.fieldArray[i].Answer2.trim() || this.fieldArray[i].Answer1.trim() === this.fieldArray[i].Answer3.trim() || this.fieldArray[i].Answer1.trim() === this.fieldArray[i].Answer4.trim() || this.fieldArray[i].Answer2.trim() === this.fieldArray[i].Answer3.trim() || this.fieldArray[i].Answer2.trim() === this.fieldArray[i].Answer4.trim() || this.fieldArray[i].Answer3.trim() === this.fieldArray[i].Answer4.trim() ){
      if(this.isSelectedTypeEqualsAlgorithm ||this.isSelectedTypeEqualsAudioAnswer ||this.isSelectedTypeEqualsVideoAnswer||this.isSelectedTypeEqualsComprehensionWithFreeText || this.isSelectedTypeEqualsFreeText){
        this.uniqueOptionNotAssigned = false;
      }else{
      this.uniqueOptionNotAssigned = true;
      }
    }
    else{
      this.uniqueOptionNotAssigned = false;
    }

    if(this.questiontextEmptyCheck == false && this.answer1EmptyCheck == false){
     console.log("Here check 1");
   if(this.answer2EmptyCheck == false && this.answer3EmptyCheck == false) {
      console.log("Here check 2");
   if(this.answer4EmptyCheck == false && this.correctAnswerEmptyCheck == false){
     console.log("Here check 3");
     if(this.correctAnswerMismatchCheck == false && this.uniqueOptionNotAssigned == false){
      this.validation_fail_of_comprehension = this.validation_fail_of_comprehension + 1;
      console.log("433",this.validation_fail_of_comprehension);
      this.allCompValidationspassed = true;
      //console.log("Printing field array before sending it to the func of checking duplicates ",this.fieldArray)
      console.log("Printing field array before sending it to the func of checking duplicates ",this.fieldArray)
      console.log("Printing COMP array before sending it to the func of checking duplicates ",this.comprehensionArray)
      if(this.isSelectedTypeEqualsComprehension){
      this.checkingDuplicatesInComprehension(this.fieldArray);
      }else{
        this.displayComprehensionTableData()
        this.resetComprehensionFields()
      }

      console.log("Printing all comp validations passed ",this.allCompValidationspassed);
      console.log("ALL OK PROCEED ")
      console.log("Karthik")
     }
   }
 }
}

else {
    console.log("KINDLY FILL ALL THE FIELDS ......")
  }

// if(this.allCompValidationspassed){
// this.displayComprehensionTableData()
// this.resetComprehensionFields()
// }else {
//   console.log("KINDLY FILL ALL THE FIELDS ......")
// }

    if(this.validation_fail_of_comprehension = 1){
      console.log("FILL ALL THE FIELDS ......")
    
    }
  }
  
  //this.displayComprehensionTableData()
  console.log("Printing the fielder last 808 ",this.fielder);
  }



  //getTableCountForComprehension = 0;
  displayComprehensionTableData(){
    //this.duplicateCompQuestionDetected = false;
    this.displayCompTableField = true;
    this.displayCompTableFieldForFreeText = true;
    console.log("Gettable count comprehension ",this.getTableCountForComprehension);
    console.log("P Field array ", this.fieldArray);
    console.log("this.comprehensionArray",this.comprehensionArray)

    
    
    console.log("Field array question text printing....",this.fieldArray[0].questionText)
    

    this.comprehensionArray[this.getTableCountForComprehension].questionText = this.fieldArray[0].questionText
    this.comprehensionArray[this.getTableCountForComprehension].Answer1 = this.fieldArray[0].Answer1
    this.comprehensionArray[this.getTableCountForComprehension].Answer2 = this.fieldArray[0].Answer2
    this.comprehensionArray[this.getTableCountForComprehension].Answer3 = this.fieldArray[0].Answer3
    this.comprehensionArray[this.getTableCountForComprehension].Answer4 = this.fieldArray[0].Answer4
    this.comprehensionArray[this.getTableCountForComprehension].Answer5 = this.fieldArray[0].Answer5
    this.comprehensionArray[this.getTableCountForComprehension].Answer6 = this.fieldArray[0].Answer6
    this.comprehensionArray[this.getTableCountForComprehension].Correct_Answer = this.fieldArray[0].Correct_Answer
   // this.comprehensionArray[this.getTableCountForComprehension].Correct_Answer = this.fieldArray[0].Correct_Answer
    this.comprehensionArray[this.getTableCountForComprehension].category = this.fieldArray[0].category
    
    this.comprehensionArray[this.getTableCountForComprehension].subcategory = this.fieldArray[0].subcategory
    
    this.comprehensionArray[this.getTableCountForComprehension].type = this.fieldArray[0].type

    this.comprehensionArray[this.getTableCountForComprehension].style = this.fieldArray[0].style
    
    this.comprehensionArray[this.getTableCountForComprehension].complexity = this.fieldArray[0].complexity
   // this.comprehensionArray[this.getTableCountForComprehension].subcategory = this.fieldArray[0].subcategory
   // this.comprehensionArray[this.gettablecount].complexity = this.fieldArray[0].complexity
    this.comprehensionArray[this.getTableCountForComprehension].questionMedia = this.fieldArray[0].questionMedia
   // this.comprehensionArray[this.gettablecount].style = this.fieldArray[0].style


   console.log("comp array question text printing....",this.comprehensionArray[this.getTableCountForComprehension].questionText)
   console.log("comp array question text printing 0th index....",this.comprehensionArray[0].questionText)
console.log("COMP ARR",this.comprehensionArray);
    this.getTableCountForComprehension = this.getTableCountForComprehension + 1;




    // if(this.comprehensionArray[this.getTableCountForComprehension].Answer1 == '' && this.comprehensionArray[this.getTableCountForComprehension].Answer2 == '' && this.comprehensionArray[this.getTableCountForComprehension].Answer3 == '' && this.comprehensionArray[this.getTableCountForComprehension].Answer4 == '' && this.comprehensionArray[this.getTableCountForComprehension].Correct_Answer == ''){
      
    //   console.log("IIIINNNNNside");
    //   this.comprehensionArray.splice(this.getTableCountForComprehension,1);
    // }



    // if (this.cardopen > 1) {
    //   // this.comprehensionArray = this.dup_fieldArray;
    //   console.log("Comp Comp Comp",this.comprehensionArray);
    //    this.dup_comprehensionArray = this.comprehensionArray

    //  console.log("Dup Dup Dup ",this.dup_comprehensionArray);
   
    //  }
    console.log('Before sending comp array into splice func ',this.comprehensionArray);
    
this.compSplicefunc(this.comprehensionArray)
console.log("After splicing comp array ",this.comprehensionArray);

  }

  compSplicefunc(compArr){
    console.log("Printing comp Arr legth ",compArr.length);
    for(var i =0;i<compArr.length;i++){
      if(compArr[i].questionText == ''){
        compArr.splice(i,1);
      }
    }
    console.log("Printing splice comp array ",compArr)
  }


  resetComprehensionFields(){
    this.duplicateCompQuestionDetected = false;
    console.log("iinside reset fieldds");
    console.log("BQT",this.fielder.questionText);
    this.fieldArray[0].questionText = '';
    console.log("AQT",this.fielder.questionText);
    this.fieldArray[0].Answer1 = '';
    this.fieldArray[0].Answer2 = '';
    this.fieldArray[0].Answer3 = '';
    this.fieldArray[0].Answer4 = '';
    this.fieldArray[0].Answer5 = '';
    this.fieldArray[0].Answer6 = '';
    this.fieldArray[0].Correct_Answer = '';
   
  }

  checkingDuplicatesInComprehension(field){

   // this.getNameForQuestionFields(this.fieldArray);
    console.log("Inside duplicate func in the comprehension");

    //console.log("Length of the comprehension array ",this.comprehensionArray.length);
    //console.log("Prnting the input Field ",field)
var counter = 0;
    console.log(`${counter} Printing the comp array `,this.comprehensionArray);
counter = counter + 1;

    // this.lastElement = this.comprehensionArray.length - 1;
    // console.log("Printing the last element of the field array ",this.lastElement);
    // if(this.comprehensionArray.length > 1){
    //   // for(var j=0;j<field.length;j++){
    // for(var i=0;i<this.comprehensionArray.length;i++){
    //   console.log("fr",this.comprehensionArray[this.lastElement].questionText);
    //   console.log("sr",this.comprehensionArray[i].questionText);
      
    //   if(this.comprehensionArray[this.lastElement].questionText == this.comprehensionArray[i].questionText && this.comprehensionArray[this.lastElement].Answer1 == this.comprehensionArray[i].Answer1 && this.comprehensionArray[this.lastElement].Answer2 == this.comprehensionArray[i].Answer2 && this.comprehensionArray[this.lastElement].Answer3 == this.comprehensionArray[i].Answer3 && this.comprehensionArray[this.lastElement].Answer4 == this.comprehensionArray[i].Answer4 && this.comprehensionArray[this.lastElement].Correct_Answer == this.comprehensionArray[i].Correct_Answer ){
    //     console.log("Question text duplication has been detected");
    //    // if(this.comprehensionArray[i].Answer1 == field[i].Answer1 && this.comprehensionArray[i].Answer2 == field[i].Answer2 && this.comprehensionArray[i].Answer3 == field[i].Answer3 && this.comprehensionArray[i].Answer4 == field[i].Answer4 && this.comprehensionArray[i].Correct_Answer == field[i].Correct_Answer){
    //       console.log("All Duplicates detected");
    //       this.isDuplicatesDetectedInComprehension = true;

    //       this.duplicateCompQuestionDetected = true;
    //       Swal.fire({
    //         title: 'Alert',
    //         text: 'Duplicate Comp Question Assigined',
    //         icon: 'warning',
    //         showCancelButton: false,
    //         confirmButtonText: 'OK'
    //       }).then((result) => {
    //         if (result.isConfirmed) {
    //         }
    //       })
    //       this.comprehensionArray.splice(-1,1);
          
        
    //   }
      
    // }


    this.lastElement = this.fieldArray.length - 1;
    console.log("Printing the last element of the field array ",this.lastElement);
    if(this.comprehensionArray.length > 1){
      // for(var j=0;j<field.length;j++){
    for(var i=0;i<this.comprehensionArray.length;i++){
      console.log("fr",this.fieldArray[this.lastElement].questionText);
      console.log("sr",this.comprehensionArray[i].questionText);
      
      if(this.fieldArray[this.lastElement].questionText == this.comprehensionArray[i].questionText){
        console.log("Question text duplication has been detected");
       // if(this.comprehensionArray[i].Answer1 == field[i].Answer1 && this.comprehensionArray[i].Answer2 == field[i].Answer2 && this.comprehensionArray[i].Answer3 == field[i].Answer3 && this.comprehensionArray[i].Answer4 == field[i].Answer4 && this.comprehensionArray[i].Correct_Answer == field[i].Correct_Answer){
          console.log("All Duplicates detected");
          //this.isDuplicatesDetectedInComprehension = true;

          this.duplicateCompQuestionDetected = true;
          Swal.fire({
            title: 'Alert',
            text: 'Duplicate Comp Question Assigined',
            icon: 'warning',
            showCancelButton: false,
            confirmButtonText: 'OK'
          }).then((result) => {
            if (result.isConfirmed) {
            }
          })

         // alert("Duplicate Question detected");
         // this.fieldArray.splice(-1,1);
          this.resetComprehensionFields();
          
        
      }
      
    }
    console.log("Printing the boolean of the dup Comp Question Detected ",this.duplicateCompQuestionDetected);
    if(this.duplicateCompQuestionDetected != true){
      //here
      console.log("Inside 55");
     this.displayComprehensionTableData()
      this.resetComprehensionFields()

    // }else{
    //   console.log("No duplicates detected");
    //   this.displayComprehensionTableData()
    //   this.resetComprehensionFields()
    // }
    }
 
  // }
  }else{
    //here
    
    console.log("56");
    this.displayComprehensionTableData()
      this.resetComprehensionFields()
  }

    
    
    
  }



  removeDuplicates(field){
    for(var i=0;i<field.length;i++){
      console.log("11111",i);
      if(field[i].questionText == field[i+1].questionText){
        field.splice(i,1);
      }
    }
  }










}

